<template>
  <v-col cols="12">
    <template>
        <v-dialog v-model="eliminar" persistent max-width="500px" :key="eliminar">
          <v-card>
            <v-card-title class="headline">¿Está seguro que desea eliminar<br/>esta máquina?</v-card-title>
            <v-card-text>Esta acción no se puede revertir y será permanente.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="eliminar = false; delItem = '';">Cancelar</v-btn>
              <v-btn color="red darken-1" text @click="eliminar = false; deleteItemDB()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </template>
    <template>
        <v-dialog v-model="dialogAddImg" persistent max-width="500px" :key="dialogAddImg">
          <v-card>
            <v-card-title class="headline">Agregar Nueva Imagen</v-card-title>
            <v-card-text>
              <v-col v-if="erroresImagen.length>0" justify="center" cols="12" sm="12" md="12">
                 <ul>
                    <li class="red--text" v-for="ex in erroresImagen" :key="ex">{{ ex }}</li>
                  </ul>
              </v-col>
              <v-col justify="center" cols="12" sm="12" md="12">
                <v-text-field v-model="uploadImg.descripcion" label="Descripción de la Imagen"></v-text-field>
                <v-file-input v-model="imagenArchivo" @change="vistaPrevia()" accept=".jpg,.jpeg,.png,.gif" label="Selecione una Imagen"></v-file-input>
                Vista Previa de la Imagen:
                <v-img :src="imagenVistaPrevia" :key="imagenVistaPrevia"></v-img>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogAddImg = false; imagenVistaPrevia = ''; imagenArchivo=null; uploadImg = defaultUploadImg; erroresImagen=[];">Cancelar</v-btn>
              <v-btn color="red darken-1" text @click="eliminar = false; agregarImagenDB()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </template>
    <template>
        <v-dialog v-model="dialogImg" persistent max-width="500px" :key="dialogImg">
          <v-card>
            <v-card-text>
              <br>
              <v-text-field readonly v-model="imagen.descripcion" label="Descripción de la Imagen"></v-text-field>
                <v-card flat tile class="d-flex">
                  <v-img
                    :src="imagen.img"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="dialogImg = false; deleteImgDB();">Eliminar</v-btn>
              <v-btn color="blue darken-1" text @click="dialogImg = false; imagen=defaultImagen;">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </template>
    <template>
        <v-dialog v-model="view" persistent max-width="500px" :key="view">
          <v-card>
            <v-card-title class="headline">Detalles de {{viewedItem.nombre}}</v-card-title>
            <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-autocomplete
                        v-model="viewedItem.esMaquina"
                        label="Tipo"
                        :items="tipos"
                        item-value="value"
                        item-text="name"
                        readonly
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="viewedItem.idMaquinaCategoria"
                        label="Categoría"
                        :items="categorias"
                        item-value="idMaquinaCategoria"
                        item-text="nombre"
                        readonly
                      ></v-autocomplete>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="12" v-if="!esAlgunaCategoriaEspecifica">
                      <v-autocomplete
                        v-model="viewedItem.idMaquinaTipo"
                        :items="clasificaciones"
                        label="Grupo de Máquinas"
                        item-text="nombre"
                        readonly
                        item-value="idMaquinaTipo"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="esAlgunaCategoriaEspecifica">
                      <v-autocomplete
                        v-model="viewedItem.idUbicacion"
                        label="Ubicación"
                        :items="ubicaciones"
                        item-value="idUbicacion"
                        item-text="nombre"
                        readonly
                      >
                      </v-autocomplete>
                    </v-col>
                    <template v-if="!esAlgunaCategoriaEspecifica">
                      <v-col class="d-flex" cols="12" sm="12">
                        <v-autocomplete
                          v-model="viewedItem.idArea"
                          :items="areas"
                          label="Área"
                          item-text="nombre"
                          readonly
                          item-value="idArea"
                        ></v-autocomplete>
                      </v-col>
                    </template>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[0])">
                      <v-select
                        v-model="viewedItem.tipoBascula"
                        label="Tipo de Bascula"
                        :items="tiposBascula"
                        readonly
                      ></v-select>
                    </v-col>
                    <v-col justify="center" cols="6" sm="6" md="6">
                      <v-text-field readonly v-model="viewedItem.marca" :label="esAlgunaCategoriaEspecifica ? 'Marca' : 'Marca de la '+tipoLabel"></v-text-field>
                    </v-col>
                    <v-col justify="center" cols="6" sm="6" md="6">
                      <v-text-field readonly v-model="viewedItem.modelo" :label="esAlgunaCategoriaEspecifica ? 'Modelo' : 'Modelo de la '+tipoLabel"></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2])">
                      <v-select
                        v-model="viewedItem.tipoTransporte"
                        label="Tipo de Unidad"
                        :items="tiposTransporte"
                        readonly
                      ></v-select>
                    </v-col>
                    <v-subheader>Número de Personas para Operar esta {{tipoLabel}}</v-subheader>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <br>
                      <v-slider
                        v-model="viewedItem.numOperadores"
                        min="0"
                        max="10"
                        thumb-label="always"
                        readonly
                      >
                      </v-slider>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2])">
                      <v-text-field
                        v-model="viewedItem.kilometrajeActual"
                        label="Kilometraje actual"
                        :loading="loadingKilometrajeActual"
                        suffix="Km"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2])">
                      <v-text-field
                        v-model="viewedItem.version"
                        label="Versión"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2])">
                      <v-text-field
                        v-model="viewedItem.placas"
                        label="Placas"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esAlgunaCategoriaEspecifica">
                      <v-text-field
                        v-model="viewedItem.numSerie"
                        label="Número de serie"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2])">
                      <v-text-field
                        v-model="viewedItem.numDeMotor"
                        label="No. de motor"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col justify="center" cols="12" sm="12" md="12" v-if="permisoVista('maquinas','$')">
                      <v-text-field readonly type="number" v-model="viewedItem.costoHora" :label="'Costo Por Hora de la '+tipoLabel"></v-text-field>
                    </v-col>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-text-field readonly v-model="viewedItem.descripcionGeneral" :label="'Descripción General de la '+tipoLabel"></v-text-field>
                    </v-col>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-text-field readonly v-model="viewedItem.descripcionTecnica" :label="'Descripción Técnica de la '+tipoLabel"></v-text-field>
                    </v-col>
                    <v-col justify="center" cols="6" sm="6" md="6">
                      <v-text-field readonly v-model="viewedItem.fechaFabricacion" :label="'Fecha de Fabricación de la '+tipoLabel"></v-text-field>
                    </v-col>
                    <v-col justify="center" cols="6" sm="6" md="6">
                      <v-text-field readonly v-model="viewedItem.fechaCompra" :label="'Fecha de Compra de la '+tipoLabel"></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2]) && viewedItem.tipoTransporte == 1">
                      <v-text-field
                        v-model="viewedItem.fechaVencimientoVerificacion"
                        label="Fecha de Vencimiento Verificación"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2]) && viewedItem.tipoTransporte == 2">
                      <v-text-field
                        v-model="viewedItem.tarjetaMercantilVencimiento"
                        label="Tarjeta Mercantil Vencimiento"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[0])">
                      <v-text-field
                        v-model="viewedItem.alcanceMaxMedicion"
                        label="Alcance Máximo de Medición"
                        type="number"
                        hide-spin-buttons
                        readonly
                      ></v-text-field>
                    </v-col>
                    <template v-if="esCategoriaEspecifica(tiposCategorias[1])">
                      <v-col cols="12">
                        <v-text-field
                          v-model="viewedItem.motor"
                          label="Motor"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="viewedItem.capacidad"
                          label="Capacidad (libras)"
                          type="number"
                          hide-spin-buttons
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="viewedItem.numCilindros"
                          label="Número de cilindros"
                          type="number"
                          hide-spin-buttons
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="viewedItem.mastilEtapas"
                          label="Mástil (Etapas)"
                          type="number"
                          hide-spin-buttons
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="viewedItem.propuestaNuevaNomenclatura"
                          label="Propuesta de nueva nomenclatura"
                          readonly
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="viewedItem.idUsuario"
                          label="Validado por"
                          :items="usuarios"
                          item-text="nombre"
                          item-value="idUsuario"
                          readonly
                        ></v-autocomplete>
                      </v-col>
                    </template>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-autocomplete
                        v-model="viewedItem.habilidades"
                        :items="habilidades"
                        label="Habilidades"
                        item-text="nombre"
                        chips
                        multiple
                        readonly
                        item-value="idHabilidad"
                      ></v-autocomplete>
                    </v-col>
                    <v-expansion-panels cols="12" sm="12" md="12" multiple accordion>
                      <v-expansion-panel>
                        <v-expansion-panel-header>Imagenes:</v-expansion-panel-header>
                        <v-expansion-panel-content cols="12" sm="12" md="12">
                          <v-row>
                          <v-col class ="d-flex child-flex" cols="4">
                            <v-card flat tile class="d-flex" outlined @click="agregarImagen()">
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-icon>add</v-icon>
                              </v-row>
                            </v-card>
                          </v-col>
                          <v-col
                            v-for="img in this.viewedItem.imagenes"
                            :key="img.idImagen"
                            @click="imagenCompleta(img)"
                            class="d-flex child-flex"
                            cols="4"
                          >
                            <v-card flat tile class="d-flex">
                              <v-img
                                :src="img.img"
                                aspect-ratio="1"
                                class="grey lighten-2"
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-card>
                          </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Operarios
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                           <v-simple-table>
                              <thead>
                                <tr>
                                  <th class="text-center">Nombre</th>
                                  <th class="text-center"># Habilidades</th>
                                  <th class="text-center">Porcentaje</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="persona in viewedItem.personas" :key="persona.idPersona">
                                  <td class="text-center">{{ getNombreCompleto(persona.idPersona)  }}</td>
                                  <td class="text-center">{{ persona.nHabilidades }}</td>
                                  <td class="text-center">{{ ( isNaN((persona.nHabilidades/persona.hRequeridas)*100) ? 100 : ((persona.nHabilidades/persona.hRequeridas)*100) ).toFixed(2)  }}%</td>
                                </tr>
                              </tbody>
                          </v-simple-table>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-row>
                </v-container>
              </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="close()" :disabled="loadingKilometrajeActual">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </template>
    <v-card class="machine-config-card" elevation="0">
      <div class="machine-config-card__glow"></div>

      <div class="machine-config-card__header">
        <div>
          <div class="machine-config-card__eyebrow">Configuracion</div>
          <h2 class="machine-config-card__title">
            {{ sensoresTokenMaquina ? "Asignacion de Maquinas y Herramientas" : "Inventario de Maquinas y Herramientas" }}
          </h2>
          <p class="machine-config-card__subtitle">
            {{ sensoresTokenMaquina
              ? "Relaciona cada instancia con sus tokens y variables con una interfaz consistente con Sensores y Variables."
              : "Administra el inventario, herramientas y datos operativos de cada recurso desde una sola vista." }}
          </p>
        </div>
      </div>

      <v-col class="d-flex justify-start" cols="6"><v-btn color="primary" :disabled="loading" dark class="mb-2" @click="dialog=true" v-if="permisoVista('maquinas','c')">Nueva Máquina/Herramienta</v-btn></v-col>
      <v-col class="d-flex justify-end" cols="6">
        
          <DownloadBtn
          text
          color="primary"  
          @click="descargarFormato()"
          label="Descargar formato de <br> carga masiva"
        />

        <v-btn
					
					text
					color="primary"
					class="mr-3"
					:disabled="loadingSubir || loadingDescargar"
					:loading="loadingSubir"
					@click="cargaMasiva = true"
				>
					subir archivo para <br> Carga Masiva
				</v-btn>
        
        </v-col>
      <div>
        <v-data-table
          v-if="permisoVista('maquinas','r')"
          class="machine-config-table"
          :headers="computedHeaders"
          :items="maquinas"
        :search="search"
        :loading="loading"
        loading-text="Cargando... Espere, Por Favor."
      >
      <template v-slot:top>
        <div class="machine-config-card__toolbar machine-config-card__toolbar--table">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar por nombre, marca, modelo o categoria"
            single-line
            hide-details
            outlined
            dense
            class="machine-config-card__search"
          ></v-text-field>

          <v-btn text color="primary" @click="initialize">
            <v-icon left small>mdi-refresh</v-icon>
            Refrescar
          </v-btn>
        </div>
      </template>
      <template v-slot:[`item.tipo`]="{ item }">
        <v-chip
          small
          outlined
          :color="item.esMaquina ? 'primary' : 'deep-purple darken-1'"
          class="machine-type-chip"
        >
          <v-icon left x-small>
            {{ item.esMaquina ? 'mdi-robot-industrial' : 'mdi-hammer-wrench' }}
          </v-icon>
          {{ item.tipo || (item.esMaquina ? 'Maquina' : 'Herramienta') }}
        </v-chip>
      </template>
      <template v-slot:[`item.nombre`]="{ item }">
        <div class="machine-name-cell">
          <div class="machine-name-cell__icon">
            <v-icon color="primary" small>
              {{ item.esMaquina ? 'mdi-cog-outline' : 'mdi-tools' }}
            </v-icon>
          </div>
          <div>
            <div class="machine-name-cell__title">{{ item.nombre || 'Sin nombre' }}</div>
            <div class="machine-name-cell__caption">
              {{ item.categoria || 'Sin categoria' }} · {{ item.marca || 'Sin marca' }} {{ item.modelo || '' }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:[`item.idUbicacion`]="{ item }">
        {{ getNombreUbicacion(item.idUbicacion) }}
      </template>
      <template v-slot:[`item.maquinaTipo`]="{ item }">
        {{ `${item.maquinaTipo==null?'N/A':item.maquinaTipo}` }}
      </template>
      <template v-slot:[`item.importancia`]="{ item }">
        <!-- Template (Vuetify 2) para mostrar 0–100 como 0–5 estrellas (con medios) -->
          <div class="d-flex align-center" :title="`${item.importancia}%`">
            <!-- Tooltip por estrella (Vuetify 2) -->
            <template v-for="n in 5">
              <v-tooltip color="black" bottom :key="`star-${n}`">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1"
                    color="primary"
                  >
                    {{
                      item.importancia >= n * 20
                        ? 'mdi-star'
                        : item.importancia >= (n * 20 - 10)
                          ? 'mdi-star-half-full'
                          : 'mdi-star-outline'
                    }}
                  </v-icon>
                </template>
                <span class="white--text">{{ item.importancia }} puntos de importancia</span>
              </v-tooltip>
            </template>
          </div>
      </template>
      
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
        <v-btn v-on="on"
          v-if="permisoVista('maquinas','r')"
          icon
          small
          color="blue darken-1"
          :disabled="loading"
          class="mr-1"
          @click="viewItem(item)"
        >
          <v-icon small>mdi-eye-outline</v-icon>
        </v-btn>
         </template>
          <span class="white--text">Ver detalles</span>
        </v-tooltip>
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
        <v-btn v-on="on"
          v-if="permisoVista('maquinas','u') && !sensoresTokenMaquina"
          icon
          small
          color="primary"
          :disabled="loading"
          class="mr-1"
          @click="editItem(item)"
        >
          <v-icon small>mdi-pencil-outline</v-icon>
        </v-btn>
         </template>
          <span class="white--text">Editar</span>
        </v-tooltip>
        <v-tooltip v-if="sensoresTokenMaquina && permisoVista('maquinas','r')" bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              color="primary"
              class="mr-2"
              :disabled="loading"
              @click="openConfiguracionMaquina(item)"
            >
              <v-icon left small>mdi-tune-variant</v-icon>
              Configurar
            </v-btn>
          </template>
          <span class="white--text">Configurar tokens y variables</span>
        </v-tooltip>
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
        <v-btn v-on="on"
          v-if="permisoVista('maquinas','d')"
          icon
          small
          color="red darken-1"
          :disabled="loading"
          class="mr-1"
          @click="deleteItem(item)"
        >
          <v-icon small>mdi-delete-outline</v-icon>
        </v-btn>
         </template>
          <span class="white--text">Eliminar</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <div class="machine-empty-state">
          <v-icon color="blue-grey lighten-1" large>
            {{ sensoresTokenMaquina ? 'mdi-connection' : 'mdi-robot-industrial' }}
          </v-icon>
          <div class="machine-empty-state__title">
            {{ sensoresTokenMaquina ? 'No hay maquinas listas para asignacion' : 'No hay maquinas o herramientas registradas' }}
          </div>
          <div class="machine-empty-state__subtitle">
            {{ sensoresTokenMaquina
              ? 'Crea o carga instancias para comenzar a relacionarlas con tokens y variables.'
              : 'Agrega un nuevo recurso o refresca el listado para volver a cargar la informacion.' }}
          </div>
        </div>
      </template>
    </v-data-table>
      </div>
    </v-card>
      <v-dialog v-model="dialog" persistent max-width="500px" :key="dialog">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-autocomplete
                        v-model="editedItem.esMaquina"
                        label="Tipo"
                        :items="tipos"
                        item-value="value"
                        item-text="name"
                        @change="resetIdMaquina()"
                        :error-messages="erroresItem.errorEsMaquina"
                        @focus="erroresItem.errorEsMaquina = null"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-autocomplete
                        v-model="editedItem.idMaquinaCategoria"
                        label="Categoría"
                        :items="categorias"
                        item-value="idMaquinaCategoria"
                        item-text="nombre"
                        :error-messages="erroresItem.erroridMaquinaCategoria"
                        @focus="erroresItem.erroridMaquinaCategoria = null"
                        @change="onChangeCategoria()"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="esAlgunaCategoriaEspecifica">
                      <v-autocomplete
                        v-model="editedItem.idUbicacion"
                        label="Ubicación"
                        :items="ubicaciones"
                        item-value="idUbicacion"
                        item-text="nombre"
                        :error-messages="erroresItem.errorUbicacion"
                        @focus="erroresItem.errorUbicacion = null"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col class="d-flex" cols="11" sm="11">
                      <v-autocomplete
                        v-model="editedItem.idMaquina"
                        :items="catMaquinasFiltrado"
                        :label="esAlgunaCategoriaEspecifica ? 'Modelos' : 'Modelos de '+tipoLabel+'s'"
                        :item-text="marcaModelo"
                        :persistent-hint="editedItem.idMaquinaCategoria == null"
                        :hint="editedItem.idMaquinaCategoria == null ? 'Debe seleccionar una Categoría' : ''"
                        :disabled="loadingArea || editedItem.idMaquinaCategoria == null"
                        :loading="loadingArea"
                        item-value="idMaquina"
                        :error-messages="erroresItem.erroridMaquina"
                        @focus="erroresItem.erroridMaquina = null"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ `${data.item.marca} - ${data.item.modelo}` }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ data.item.descripcionGeneral }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-icon
                      class="mr-2"
                      :disabled="loadingArea"
                      @click="getCatMaquinas()"
                    >
                      mdi-reload
                    </v-icon>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2])">
                      <v-select
                        v-model="editedItem.tipoTransporte"
                        label="Tipo de Unidad"
                        :items="tiposTransporte"
                        :disabled="saving"
                        :error-messages="erroresItem.errorTipoTransporte"
                        @focus="erroresItem.errorTipoTransporte = null"
                        @change="onChangeTipoTransporte"
                      ></v-select>
                    </v-col>
                    <template v-if="!esAlgunaCategoriaEspecifica">
                      <v-col class="d-flex" cols="11" sm="11">
                        <v-autocomplete
                          v-model="editedItem.idMaquinaTipo"
                          :items="clasificaciones"
                          label="Grupo de Máquinas"
                          item-text="nombre"
                          :disabled="loadingClasificacion"
                          :loading="loadingClasificacion"
                          item-value="idMaquinaTipo"
                        ></v-autocomplete>
                      </v-col>
                      <v-icon
                        class="mr-2"
                        :disabled="loadingClasificacion"
                        @click="getClasificaciones()"
                      >
                        mdi-reload
                      </v-icon>
                    </template>
                    <template v-if="!esAlgunaCategoriaEspecifica">
                      <v-col class="d-flex" cols="11" sm="11">
                        <v-autocomplete
                          v-model="editedItem.idArea"
                          :items="areas"
                          label="Área"
                          item-text="nombre"
                          :disabled="loadingArea"
                          :loading="loadingArea"
                          item-value="idArea"
                          :error-messages="erroresItem.erroridArea"
                          @focus="erroresItem.erroridArea = null"
                        ></v-autocomplete>
                      </v-col>
                      <v-icon
                        class="mr-2"
                        :disabled="loadingArea"
                        @click="getAreas()"
                      >
                        mdi-reload
                      </v-icon>
                    </template>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-text-field 
                        v-model="editedItem.nombre" 
                        :label="computedLabel"
                        :error-messages="erroresItem.errornombre"
                        @focus="erroresItem.errornombre = null"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[0])">
                      <v-select
                        v-model="editedItem.tipoBascula"
                        label="Tipo de Bascula"
                        :items="tiposBascula"
                        :disabled="saving"
                        :error-messages="erroresItem.errorTipoBascula"
                        @focus="erroresItem.errorTipoBascula = null"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2])">
                      <v-text-field
                        v-model="editedItem.version"
                        label="Versión"
                        clearable
                        :disabled="saving"
                        :error-messages="erroresItem.errorVersion"
                        @focus="erroresItem.errorVersion = null"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2])">
                      <v-text-field
                        v-model="editedItem.placas"
                        label="Placas"
                        :disabled="saving"
                        :error-messages="erroresItem.errorPlacas"
                        @focus="erroresItem.errorPlacas = null"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esAlgunaCategoriaEspecifica">
                      <v-text-field
                        v-model="editedItem.numSerie"
                        label="Número de serie"
                        :disabled="saving"
                        :error-messages="erroresItem.errorNumSerie"
                        @focus="erroresItem.errorNumSerie = null"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2])">
                      <v-text-field
                        v-model="editedItem.numDeMotor"
                        label="No. de motor"
                        :disabled="saving"
                        :error-messages="erroresItem.errorNumMotor"
                        @focus="erroresItem.errorNumMotor = null"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <MenuDatepicker
                        v-model="editedItem.fechaFabricacion"
                        :label="`Fecha de Fabricación de la ${tipoLabel}`"
                        :max-date="today"
                        clearable
                        :disabled="saving"
                        :errorMessage="erroresItem.errorfechaFabricacion"
                        @focus="erroresItem.errorfechaFabricacion = null"
                      />
                    </v-col>
                    <v-col cols="6">
                      <MenuDatepicker
                        v-model="editedItem.fechaCompra"
                        :label="`Fecha de Compra de la ${tipoLabel}`"
                        :max-date="today"
                        clearable
                        :disabled="saving"
                        :errorMessage="erroresItem.errorfechaCompra"
                        @focus="erroresItem.errorfechaCompra = null"
                      />
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2]) && editedItem.tipoTransporte == 1">
                      <MenuDatepicker
                        v-model="editedItem.fechaVencimientoVerificacion"
                        label="Fecha de Vencimiento Verificación"
                        clearable
                        :disabled="saving"
                      />
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[2]) && editedItem.tipoTransporte == 2">
                      <MenuDatepicker
                        v-model="editedItem.tarjetaMercantilVencimiento"
                        label="Tarjeta Mercantil Vencimiento"
                        clearable
                        :disabled="saving"
                      />
                    </v-col>
                    <v-col cols="12" v-if="esCategoriaEspecifica(tiposCategorias[0])">
                      <v-text-field
                        v-model="editedItem.alcanceMaxMedicion"
                        label="Alcance Máximo de Medición"
                        type="number"
                        hide-spin-buttons
                        :disabled="saving"
                        :error-messages="erroresItem.errorAlcanceMaxMed"
                        @focus="erroresItem.errorAlcanceMaxMed = null"
                      ></v-text-field>
                    </v-col>
                    <template v-if="esCategoriaEspecifica(tiposCategorias[1])">
                      <v-col cols="12">
                        <v-autocomplete-textfield
                          v-model="editedItem.motor"
                          :items="motoresMontacargas"
                          label="Motor"
                          :loading="loadingMotoresMontacargas"
                          :disabled="saving"
                          @click:refresh="getMotoresMontacargas"
                          :errorMessage="erroresItem.errorMotor"
                          @update:error-message="erroresItem.errorMotor = $event"
                        ></v-autocomplete-textfield>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="editedItem.capacidad"
                          label="Capacidad (libras)"
                          type="number"
                          hide-spin-buttons
                          :disabled="saving"
                          :error-messages="erroresItem.errorCapacidad"
                          @focus="erroresItem.errorCapacidad = null"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="editedItem.numCilindros"
                          label="No. de cilindros"
                          type="number"
                          hide-spin-buttons
                          :disabled="saving"
                          :error-messages="erroresItem.errorNumCilindros"
                          @focus="erroresItem.errorNumCilindros = null"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="editedItem.mastilEtapas"
                          label="Mástil (Etapas)"
                          type="number"
                          hide-spin-buttons
                          :disabled="saving"
                          :error-messages="erroresItem.errorMastilEtapas"
                          @focus="erroresItem.errorMastilEtapas = null"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="editedItem.propuestaNuevaNomenclatura"
                          label="Propuesta de nueva nomenclatura"
                          clearable
                          :disabled="saving"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="editedItem.idUsuario"
                          label="Validado por"
                          :items="usuarios"
                          item-text="nombre"
                          item-value="idUsuario"
                          :loading="loadingUsuarios"
                          :disabled="saving || loadingUsuarios"
                          :error-messages="erroresItem.errorUsuario"
                          @focus="erroresItem.errorUsuario = null"
                        ></v-autocomplete>
                      </v-col>
                    </template>
                    <template v-if="!esAlgunaCategoriaEspecifica && !sensoresTokenMaquina">
                      <v-col cols="12">
                        <InputToken
                          :key="`intok1-${chkey}`"
                          v-model="editedItem.token"
                          label="Token 1"
                          appendIcon1="mdi-lock"
                          appendIcon2="mdi-lock-open"
                          :locked="editedIndex!=-1"
                          :error-messages="erroresItem.errortoken"
                          @focus="erroresItem.errortoken = null"
                          @input="editedItem.token=$event"
                        />
                        <span @click="AddDropTokens(editedItem)" class="clickable-text">
                          Agregar o quitar tokens extras
                        </span>
                      </v-col>
                      <v-col cols="12">
                        <InputToken
                          :key="`intok2-${chkey}`"
                          v-model="editedItem.token2"
                          label="Token 2"
                          appendIcon1="mdi-lock"
                          appendIcon2="mdi-lock-open"
                          :locked="editedIndex!=-1"
                          :error-messages="erroresItem.errortoken2"
                          @focus="erroresItem.errortoken2 = null"
                          @input="editedItem.token2=$event"
                        />
                      </v-col>
                    </template>
                    <v-col cols="12">
                      <div class="d-flex align-center justify-center mb-2" :title="`${editedItem.importancia}%`">
                        <!-- Con tooltip (Vuetify 2) -->
                      <template v-for="n in 5">
                        <v-tooltip color="black" bottom :key="`edit-star-${n}`">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              class="mx-1"
                              color="amber"
                              large
                            >
                              {{
                                editedItem.importancia >= n * 20
                                  ? 'mdi-star'
                                  : editedItem.importancia >= (n * 20 - 10)
                                    ? 'mdi-star-half-full'
                                    : 'mdi-star-outline'
                              }}
                            </v-icon>
                          </template>
                          <span class="white--text">{{ editedItem.importancia }} puntos de importancia</span>
                        </v-tooltip>
                      </template>
                      </div>

                      <!-- Barra que controla la importancia (0–100) -->
                      <v-slider v-model="editedItem.importancia" min="0" max="100" step="1" class="mx-6" 
                        hide-details persistent-hint :hint="`Importancia: ${editedItem.importancia}%`" thumb-label/>

                      <!-- Listas de ejemplo (estáticas) -->
                      <v-row class="mt-4">
                        <v-col cols="12" md="4">
                          <v-subheader>{{ clasificarPorImportancia(editedItem.importancia).mas.length || "0" }} Máquina(s) con mayor importancia</v-subheader>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-subheader>{{ clasificarPorImportancia(editedItem.importancia).igual.length || "0" }} Máquina(s) con igual importancia</v-subheader>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-subheader>{{ clasificarPorImportancia(editedItem.importancia).menos.length || "0" }} Máquina(s) con menor importancia</v-subheader>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <ul>
                    <li class="red--text" v-for="ex in errores" :key="ex">{{ ex }}</li>
                  </ul>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog=false; errores=[];">Cancelar</v-btn>
                <v-btn color="red darken-1" text @click="save()" :disabled="saving" :loading="saving">
                  Guardar
                  <template v-slot:loader>
                    <v-progress-circular
                      indeterminate
                      :width="2"
                      :size="24"
                      color="red"
                    ></v-progress-circular>
                  </template>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      <v-dialog v-model="dialogAsignacionTokens" persistent max-width="900px">
        <v-card>
          <v-card-title class="headline">
            Asignación de tokens
            <span v-if="maquinaAsignacion" class="ml-2 subtitle-1 grey--text text--darken-1">
              {{ maquinaAsignacion.nombre }}
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="8">
                  <v-autocomplete
                    v-model="tokenMaquinaForm.idToken"
                    :items="tokensCatalogo"
                    item-text="token"
                    item-value="idToken"
                    label="Token"
                    :loading="loadingTokensCatalogo"
                    :disabled="savingTokenAsignacion || loadingTokensCatalogo"
                    :error-messages="erroresTokenForm.idToken"
                    @focus="erroresTokenForm.idToken = null"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>{{ data.item.token }}</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ data.item.tipoToken || 'N/A' }} | {{ data.item.descripcion || 'Sin descripción' }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" v-if="false">
                  <v-text-field
                    v-model.trim="sensorForm.tokenDispositivo"
                    label="Token"
                    :disabled="savingSensorAsignacion"
                    :error-messages="erroresSensorForm.tokenDispositivo"
                    @focus="erroresSensorForm.tokenDispositivo = null"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" v-if="false">
                  <v-text-field
                    v-model.trim="sensorForm.descripcion"
                    label="Descripción"
                    :disabled="savingSensorAsignacion"
                    :error-messages="erroresSensorForm.descripcion"
                    @focus="erroresSensorForm.descripcion = null"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn
                    v-if="tokenMaquinaForm.idTokenMaquina && permisoVista('maquinas','u')"
                    text
                    color="blue darken-1"
                    class="mr-2"
                    :disabled="savingTokenAsignacion"
                    @click="resetTokenForm"
                  >
                    Cancelar edición
                  </v-btn>
                  <v-btn
                    v-if="(tokenMaquinaForm.idTokenMaquina && permisoVista('maquinas','u')) || (!tokenMaquinaForm.idTokenMaquina && permisoVista('maquinas','c'))"
                    color="primary"
                    :loading="savingTokenAsignacion"
                    :disabled="savingTokenAsignacion || !maquinaAsignacion"
                    @click="asignarToken"
                  >
                    {{ tokenMaquinaForm.idTokenMaquina ? 'Actualizar asignación' : 'Agregar asignación' }}
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="headersTokensAsignados"
                    :items="tokensAsignados"
                    :loading="loadingTokensAsignados"
                    loading-text="Cargando asignaciones..."
                    no-data-text="No hay tokens asignados para esta máquina."
                    dense
                  >
                    <template v-slot:[`item.descripcionToken`]="{ item }">
                      {{ item.descripcionToken || 'N/A' }}
                    </template>
                    <template v-slot:[`item.condicion`]="{ item }">
                      {{ item.condicion === false ? 'Inactivo' : 'Activo' }}
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-tooltip v-if="false" bottom color="black" class="white--text">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            color="teal"
                            class="mr-2"
                            :disabled="loadingRangosSensores || savingSensorRango"
                            @click="openSensorRangos(item)"
                          >
                            mdi-tune-variant
                          </v-icon>
                        </template>
                        <span class="white--text">Configurar rangos</span>
                      </v-tooltip>
                      <v-tooltip v-if="permisoVista('maquinas','u')" bottom color="black" class="white--text">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            color="primary"
                            class="mr-2"
                            :disabled="savingTokenAsignacion"
                            @click="editTokenAsignacion(item)"
                          >
                            edit
                          </v-icon>
                        </template>
                        <span class="white--text">Editar</span>
                      </v-tooltip>
                      <v-tooltip v-if="permisoVista('maquinas','d')" bottom color="black" class="white--text">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            color="red darken-1"
                            :disabled="deletingTokenAsignacionId === item.idTokenMaquina || savingTokenAsignacion"
                            @click="deleteTokenAsignacion(item)"
                          >
                            delete
                          </v-icon>
                        </template>
                        <span class="white--text">Eliminar</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" v-if="false">
                  <v-card outlined class="mt-4">
                    <v-card-title class="subtitle-1 font-weight-bold d-flex justify-space-between align-center">
                      <span>
                        Rangos del sensor
                        <span class="grey--text text--darken-1">
                          {{ sensorRangoTarget.tipoSensorLabel }} - {{ sensorRangoTarget.tokenDispositivo }}
                        </span>
                      </span>
                      <v-btn text small color="blue darken-1" @click="closeSensorRangosPanel">
                        Cerrar
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model.trim="sensorRangoForm.cantidadMuestras"
                            label="Cantidad de muestras"
                            type="number"
                            :disabled="savingSensorRango"
                            :error-messages="erroresSensorRangoForm.cantidadMuestras"
                            @focus="erroresSensorRangoForm.cantidadMuestras = null"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model.trim="sensorRangoForm.desviacionInferior"
                            label="Desviación inferior"
                            type="number"
                            :disabled="savingSensorRango"
                            :error-messages="erroresSensorRangoForm.desviacionInferior"
                            @focus="erroresSensorRangoForm.desviacionInferior = null"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model.trim="sensorRangoForm.desviacionSuperior"
                            label="Desviación superior"
                            type="number"
                            :disabled="savingSensorRango"
                            :error-messages="erroresSensorRangoForm.desviacionSuperior"
                            @focus="erroresSensorRangoForm.desviacionSuperior = null"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="d-flex justify-end">
                          <v-btn
                            v-if="sensorRangoForm.idRango && permisoVista('sensores','u')"
                            text
                            color="blue darken-1"
                            class="mr-2"
                            :disabled="savingSensorRango"
                            @click="cancelSensorRangoEdit"
                          >
                            Cancelar edición
                          </v-btn>
                          <v-btn
                            v-if="(sensorRangoForm.idRango && permisoVista('sensores','u')) || (!sensorRangoForm.idRango && !sensorRangos.length && permisoVista('sensores','c'))"
                            color="primary"
                            :loading="savingSensorRango"
                            :disabled="savingSensorRango || !sensorRangoTarget"
                            @click="saveSensorRango"
                          >
                            {{ sensorRangoForm.idRango ? 'Actualizar configuración' : 'Guardar configuración' }}
                          </v-btn>
                        </v-col>
                        <v-col cols="12">
                          <v-data-table
                            :headers="headersSensorRangos"
                            :items="sensorRangos"
                            :loading="loadingRangosSensores"
                            loading-text="Cargando rangos..."
                            no-data-text="No hay rangos configurados para este sensor."
                            dense
                          >
                            <template v-slot:[`item.sensorLabel`]="{ item }">
                              {{ item.sensorLabel }}
                            </template>
                            <template v-slot:[`item.nombre`]="{ item }">
                              {{ item.cantidadMuestras }}
                            </template>
                            <template v-slot:[`item.descripcion`]="{ item }">
                              {{ item.desviacionInferior }}
                            </template>
                            <template v-slot:[`item.maximo`]="{ item }">
                              {{ item.desviacionSuperior }}
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                              <v-tooltip v-if="permisoVista('sensores','u')" bottom color="black" class="white--text">
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    v-on="on"
                                    small
                                    color="primary"
                                    class="mr-2"
                                    :disabled="savingSensorRango"
                                    @click="editSensorRango(item)"
                                  >
                                    edit
                                  </v-icon>
                                </template>
                                <span class="white--text">Editar</span>
                              </v-tooltip>
                              <v-tooltip v-if="permisoVista('sensores','d')" bottom color="black" class="white--text">
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    v-on="on"
                                    small
                                    color="red darken-1"
                                    :disabled="deletingSensorRangoId === item.idRango || savingSensorRango"
                                    @click="deleteSensorRango(item)"
                                  >
                                    delete
                                  </v-icon>
                                </template>
                                <span class="white--text">Eliminar</span>
                              </v-tooltip>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeAsignacionTokens">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAsignacionSensorVariables" persistent max-width="900px">
        <v-card>
          <v-card-title class="headline">
            Asignacion de variables de sensor
            <span v-if="maquinaAsignacion" class="ml-2 subtitle-1 grey--text text--darken-1">
              {{ maquinaAsignacion.nombre }}
            </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="9">
                  <v-autocomplete
                    v-model="maquinaSensorVariableForm.idSensorVariable"
                    :items="sensorVariablesDisponibles"
                    item-text="sensorVariableLabel"
                    item-value="idSensorVariable"
                    item-disabled="asignacionBloqueada"
                    label="Relacion sensor-variable"
                    :loading="loadingSensorVariablesCatalogo"
                    :disabled="savingMaquinaSensorVariable || loadingSensorVariablesCatalogo"
                    :error-messages="erroresMaquinaSensorVariableForm.idSensorVariable"
                    @focus="erroresMaquinaSensorVariableForm.idSensorVariable = null"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>{{ data.item.sensorVariableLabel }}</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ data.item.sensorNombre || 'N/A' }} | {{ data.item.variableCodigo || 'N/A' }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" class="d-flex justify-end align-center">
                  <v-btn
                    v-if="maquinaSensorVariableForm.idMaquinaSensorVariable && permisoVista('maquinas','u')"
                    text
                    color="blue darken-1"
                    class="mr-2"
                    :disabled="savingMaquinaSensorVariable"
                    @click="resetMaquinaSensorVariableForm"
                  >
                    Cancelar edicion
                  </v-btn>
                  <v-btn
                    v-if="(maquinaSensorVariableForm.idMaquinaSensorVariable && permisoVista('maquinas','u')) || (!maquinaSensorVariableForm.idMaquinaSensorVariable && permisoVista('maquinas','c'))"
                    color="primary"
                    :loading="savingMaquinaSensorVariable"
                    :disabled="savingMaquinaSensorVariable || !maquinaAsignacion || sensorVariableDuplicadaEnToken"
                    @click="saveMaquinaSensorVariable"
                  >
                    {{ maquinaSensorVariableForm.idMaquinaSensorVariable ? 'Actualizar asignacion' : 'Agregar asignacion' }}
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="headersMaquinaSensorVariables"
                    :items="maquinaSensorVariables"
                    :loading="loadingMaquinaSensorVariables"
                    loading-text="Cargando asignaciones..."
                    no-data-text="No hay relaciones sensor-variable asignadas para esta maquina."
                    dense
                  >
                    <template v-slot:[`item.sensorLabel`]="{ item }">
                      {{ item.sensorLabel }}
                    </template>
                    <template v-slot:[`item.variableLabel`]="{ item }">
                      {{ item.variableLabel }}
                    </template>
                    <template v-slot:[`item.condicion`]="{ item }">
                      {{ item.condicion === false ? 'Inactivo' : 'Activo' }}
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-tooltip v-if="permisoVista('maquinas','u')" bottom color="black" class="white--text">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            color="primary"
                            class="mr-2"
                            :disabled="savingMaquinaSensorVariable"
                            @click="editMaquinaSensorVariable(item)"
                          >
                            edit
                          </v-icon>
                        </template>
                        <span class="white--text">Editar</span>
                      </v-tooltip>
                      <v-tooltip v-if="permisoVista('maquinas','d')" bottom color="black" class="white--text">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            color="red darken-1"
                            :disabled="deletingMaquinaSensorVariableId === item.idMaquinaSensorVariable || savingMaquinaSensorVariable"
                            @click="deleteMaquinaSensorVariable(item)"
                          >
                            delete
                          </v-icon>
                        </template>
                        <span class="white--text">Eliminar</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeAsignacionSensorVariables">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogConfiguracionMaquina" persistent max-width="1180px">
        <v-card class="machine-setup-dialog" elevation="0">
          <div class="machine-setup-dialog__hero">
            <div class="machine-setup-dialog__hero-copy">
              <div class="machine-setup-dialog__eyebrow">Centro de configuracion</div>
              <h2 class="machine-setup-dialog__title">
                {{ maquinaAsignacion ? maquinaAsignacion.nombre : 'Configurando maquina' }}
              </h2>
              <p class="machine-setup-dialog__subtitle">
                Conecta tokens y variables en un solo flujo para dejar esta maquina lista para operar.
              </p>
              <div class="machine-setup-dialog__meta">
                <v-chip small outlined color="white" class="mr-2">
                  <v-icon left x-small>mdi-memory</v-icon>
                  {{ maquinaAsignacion && maquinaAsignacion.marca ? maquinaAsignacion.marca : 'Marca' }}
                </v-chip>
                <v-chip small outlined color="white">
                  <v-icon left x-small>mdi-cog-outline</v-icon>
                  {{ maquinaAsignacion && maquinaAsignacion.modelo ? maquinaAsignacion.modelo : 'Modelo' }}
                </v-chip>
              </div>
            </div>

            <div class="machine-setup-visual" aria-hidden="true">
              <div class="machine-setup-visual__orbit machine-setup-visual__orbit--outer"></div>
              <div class="machine-setup-visual__orbit machine-setup-visual__orbit--inner"></div>
              <div class="machine-setup-visual__chip machine-setup-visual__chip--token">TOKEN</div>
              <div class="machine-setup-visual__chip machine-setup-visual__chip--variable">VAR</div>
              <div class="machine-setup-visual__chip machine-setup-visual__chip--ranges">RANGOS</div>
              <div class="machine-setup-visual__core">
                <v-icon large color="white" class="machine-setup-visual__icon">mdi-robot-industrial</v-icon>
                <div class="machine-setup-visual__gear machine-setup-visual__gear--left">
                  <v-icon small color="white">mdi-cog</v-icon>
                </div>
                <div class="machine-setup-visual__gear machine-setup-visual__gear--right">
                  <v-icon small color="white">mdi-cog</v-icon>
                </div>
              </div>
            </div>
          </div>

          <v-card-text class="machine-setup-dialog__body">
            <v-row>
              <v-col cols="12" class="machine-setup-ranges-panel">
                <v-card class="machine-setup-panel rango-panel" outlined>
                  <v-card-title class="machine-setup-panel__title">
                    <div>
                      <div class="machine-setup-panel__eyebrow">Paso 3 de 3</div>
                      <div>Configuracion de rangos</div>
                      <div class="rango-panel__subtitle">
                        Define los valores para esta variable. El sistema generara alertas cuando el valor salga del margen de advertencia.
                      </div>
                    </div>
                    <v-chip small color="orange lighten-5" text-color="orange darken-3">
                      {{ rangosVariables.length }}
                    </v-chip>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="rangoVariableTargetId"
                          :items="variablesConectadasActivas"
                          item-text="rangoVariableTargetLabel"
                          item-value="idMaquinaSensorVariable"
                          label="Variable de la maquina"
                          outlined
                          dense
                          prepend-inner-icon="mdi-chart-bell-curve"
                          :loading="loadingMaquinaSensorVariables"
                          :disabled="savingRangoVariable || loadingMaquinaSensorVariables || !variablesConectadasActivas.length"
                          @change="onRangoVariableTargetChange"
                        ></v-autocomplete>
                      </v-col>

                      <!-- Variable seleccionada (info) -->
                      <v-col v-if="rangoSelectedVariable" cols="12">
                        <div class="rango-selected">
                          <div class="rango-selected__cell">
                            <div class="rango-selected__cell-label">Variable seleccionada</div>
                            <div class="rango-selected__cell-content">
                              <div class="rango-selected__icon">
                                <v-icon>mdi-sine-wave</v-icon>
                              </div>
                              <div class="rango-selected__text">
                                <div class="rango-selected__title">{{ rangoSelectedVariable.sensorNombre || 'Sensor' }}</div>
                                <div class="rango-selected__sub">
                                  {{ rangoSelectedVariable.variableCodigo }} <span v-if="rangoSelectedVariable.variableNombre">- {{ rangoSelectedVariable.variableNombre }}</span>
                                </div>
                                <div v-if="rangoSelectedVariable.unidadVariable" class="rango-selected__unidad">
                                  Unidad: <strong>{{ rangoSelectedVariable.unidadVariable }}</strong>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>

                      <v-col v-if="rangoSelectedVariable && rangosVariables.length" cols="12">
                        <div class="rango-saved-list">
                          <v-btn
                            text
                            color="blue darken-2"
                            class="rango-saved-list__toggle"
                            @click="showRangosGuardados = !showRangosGuardados"
                          >
                            <v-icon left>mdi-format-list-checks</v-icon>
                            Configuraciones guardadas
                            <v-chip x-small class="ml-2" color="blue lighten-5" text-color="blue darken-2">
                              {{ rangosVariables.length }}
                            </v-chip>
                            <v-icon right small>
                              {{ showRangosGuardados ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                            </v-icon>
                          </v-btn>
                          <v-expand-transition>
                            <div v-show="showRangosGuardados" class="rango-saved-list__table">
                              <v-data-table
                                :headers="headersRangosVariables"
                                :items="rangosVariables"
                                dense
                                hide-default-footer
                                class="machine-setup-table"
                                no-data-text="No hay configuraciones guardadas para esta variable."
                              >
                                <template v-slot:[`item.advertenciaMin`]="{ item }">
                                  {{ formatRangoNum(item.advertenciaMin) }}
                                </template>
                                <template v-slot:[`item.normalMin`]="{ item }">
                                  {{ formatRangoNum(item.normalMin) }}
                                </template>
                                <template v-slot:[`item.normalMax`]="{ item }">
                                  {{ formatRangoNum(item.normalMax) }}
                                </template>
                                <template v-slot:[`item.advertenciaMax`]="{ item }">
                                  {{ formatRangoNum(item.advertenciaMax) }}
                                </template>
                                <template v-slot:[`item.periodo`]="{ item }">
                                  {{ formatRangoPeriodo(item) }}
                                </template>
                                <template v-slot:[`item.condicion`]="{ item }">
                                  <v-chip
                                    x-small
                                    :color="item.condicion === false ? 'grey lighten-3' : 'green lighten-5'"
                                    :text-color="item.condicion === false ? 'grey darken-2' : 'green darken-3'"
                                  >
                                    {{ item.condicion === false ? 'Inactiva' : 'Activa' }}
                                  </v-chip>
                                </template>
                                <template v-slot:[`item.action`]="{ item }">
                                  <v-tooltip v-if="permisoVista('maquinas','u')" bottom color="black" class="white--text">
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        icon
                                        small
                                        :color="item.condicion === false ? 'green darken-2' : 'orange darken-2'"
                                        :disabled="savingRangoVariable || togglingRangoVariableId === item.idRango"
                                        :loading="togglingRangoVariableId === item.idRango"
                                        @click="openRangoVariableEstadoDialog(item)"
                                      >
                                        <v-icon small>
                                          {{ item.condicion === false ? 'mdi-check-circle-outline' : 'mdi-cancel' }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                    <span class="white--text">{{ item.condicion === false ? 'Activar' : 'Desactivar' }}</span>
                                  </v-tooltip>
                                  <v-tooltip v-if="permisoVista('maquinas','u')" bottom color="black" class="white--text">
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        icon
                                        small
                                        color="primary"
                                        :disabled="savingRangoVariable"
                                        @click="editRangoVariable(item)"
                                      >
                                        <v-icon small>mdi-pencil-outline</v-icon>
                                      </v-btn>
                                    </template>
                                    <span class="white--text">Editar</span>
                                  </v-tooltip>
                                </template>
                              </v-data-table>
                            </div>
                          </v-expand-transition>
                        </div>
                      </v-col>

                      <!-- ============================================
                           VISTA SAVED: la variable ya tiene un rango
                           ============================================ -->
                      <v-col v-if="rangoEstadoVista === 'view' && rangoBarSavedVisible" cols="12">
                        <div class="rango-saved-banner">
                          <v-icon color="#16a34a">mdi-check-circle</v-icon>
                          <div class="rango-saved-banner__text">
                            <div class="rango-saved-banner__title">
                              Configuracion guardada
                              <v-chip
                                x-small
                                class="ml-2"
                                :color="rangoVariableExistente.condicion === false ? 'grey lighten-3' : 'green lighten-5'"
                                :text-color="rangoVariableExistente.condicion === false ? 'grey darken-2' : 'green darken-3'"
                              >
                                {{ rangoVariableExistente.condicion === false ? 'Inactiva' : 'Activa' }}
                              </v-chip>
                            </div>
                            <div class="rango-saved-banner__sub">
                              {{ rangoVariableExistente.condicion === false
                                ? 'Esta configuracion conserva sus valores, pero no participa en alertas hasta reactivarse.'
                                : 'Esta variable ya tiene una configuracion activa. Puedes editarla o desactivarla sin perder sus valores.' }}
                            </div>
                          </div>
                          <div class="rango-saved-banner__actions">
                            <v-btn
                              v-if="permisoVista('maquinas','u')"
                              text
                              color="blue darken-2"
                              :disabled="savingRangoVariable"
                              @click="editRangoVariable(rangoVariableExistente)"
                            >
                              <v-icon left small>mdi-pencil-outline</v-icon>
                              Editar
                            </v-btn>
                            <v-btn
                              v-if="permisoVista('maquinas','u')"
                              text
                              :color="rangoVariableExistente.condicion === false ? 'green darken-2' : 'orange darken-2'"
                              :disabled="savingRangoVariable || togglingRangoVariableId === rangoVariableExistente.idRango"
                              :loading="togglingRangoVariableId === rangoVariableExistente.idRango"
                              @click="openRangoVariableEstadoDialog(rangoVariableExistente)"
                            >
                              <v-icon left small>
                                {{ rangoVariableExistente.condicion === false ? 'mdi-check-circle-outline' : 'mdi-cancel' }}
                              </v-icon>
                              {{ rangoVariableExistente.condicion === false ? 'Activar' : 'Desactivar' }}
                            </v-btn>
                          </div>
                        </div>
                      </v-col>

                      <!-- Vista previa (saved) -->
                      <v-col v-if="rangoEstadoVista === 'view' && rangoBarSavedVisible" cols="12">
                        <div class="rango-preview">
                          <div class="rango-preview__head">
                            <v-icon small>mdi-eye-outline</v-icon>
                            VISTA PREVIA DE LOS RANGOS
                          </div>
                          <div class="rango-bar-legend">
                            <div v-if="rangoBarSaved.alarmaBaja" class="rango-bar-legend__item rango-bar-legend__item--alarma">
                              <div class="rango-bar-legend__title">ALARMA</div>
                              <div class="rango-bar-legend__range">(&lt; {{ formatRangoNum(rangoBarSaved.alarmaBaja.upper) }} {{ rangoUnidad }})</div>
                            </div>
                            <div v-if="rangoBarSaved.advBaja" class="rango-bar-legend__item rango-bar-legend__item--adv">
                              <div class="rango-bar-legend__title">ADVERTENCIA</div>
                              <div class="rango-bar-legend__range">({{ formatRangoNum(rangoBarSaved.advBaja.lower) }} - {{ formatRangoNum(rangoBarSaved.advBaja.upper) }} {{ rangoUnidad }})</div>
                            </div>
                            <div class="rango-bar-legend__item rango-bar-legend__item--normal">
                              <div class="rango-bar-legend__title">NORMAL</div>
                              <div class="rango-bar-legend__range">({{ formatRangoNum(rangoBarSaved.normal.lower) }} - {{ formatRangoNum(rangoBarSaved.normal.upper) }} {{ rangoUnidad }})</div>
                            </div>
                            <div v-if="rangoBarSaved.advAlta" class="rango-bar-legend__item rango-bar-legend__item--adv">
                              <div class="rango-bar-legend__title">ADVERTENCIA</div>
                              <div class="rango-bar-legend__range">({{ formatRangoNum(rangoBarSaved.advAlta.lower) }} - {{ formatRangoNum(rangoBarSaved.advAlta.upper) }} {{ rangoUnidad }})</div>
                            </div>
                            <div v-if="rangoBarSaved.alarmaAlta" class="rango-bar-legend__item rango-bar-legend__item--alarma">
                              <div class="rango-bar-legend__title">ALARMA</div>
                              <div class="rango-bar-legend__range">(&gt; {{ formatRangoNum(rangoBarSaved.alarmaAlta.lower) }} {{ rangoUnidad }})</div>
                            </div>
                          </div>
                          <div class="rango-bar">
                            <div
                              v-for="(seg, i) in rangoBarSaved.segments"
                              :key="'savedseg-' + i"
                              class="rango-bar__seg"
                              :class="'rango-bar__seg--' + seg.kind"
                              :style="{ flex: seg.flex }"
                            ></div>
                          </div>
                          <div class="rango-bar-axis">
                            <span v-for="(tick, i) in rangoBarSaved.ticks" :key="'savedtick-' + i" class="rango-bar-axis__tick" :style="{ left: tick.pos + '%' }">
                              {{ formatRangoNum(tick.value) }}
                            </span>
                          </div>
                        </div>
                      </v-col>

                      <!-- Resumen (saved) -->
                      <v-col v-if="rangoEstadoVista === 'view' && rangoBarSavedVisible" cols="12">
                        <div class="rango-summary">
                          <div class="rango-summary__head">
                            <v-icon small>mdi-clipboard-text-outline</v-icon>
                            RESUMEN DE CONFIGURACION
                          </div>
                          <div class="rango-summary__grid">
                            <div v-if="rangoBarSaved.alarmaBaja" class="rango-summary__cell rango-summary__cell--alarma">
                              <div class="rango-summary__label">ALARMA BAJA</div>
                              <div class="rango-summary__sub">Menor que</div>
                              <div class="rango-summary__value">{{ formatRangoNum(rangoBarSaved.alarmaBaja.upper) }} {{ rangoUnidad }}</div>
                            </div>
                            <div v-if="rangoBarSaved.advBaja" class="rango-summary__cell rango-summary__cell--adv">
                              <div class="rango-summary__label">ADVERTENCIA INFERIOR</div>
                              <div class="rango-summary__sub">Entre</div>
                              <div class="rango-summary__value">{{ formatRangoNum(rangoBarSaved.advBaja.lower) }} {{ rangoUnidad }} &mdash; {{ formatRangoNum(rangoBarSaved.advBaja.upper) }} {{ rangoUnidad }}</div>
                            </div>
                            <div class="rango-summary__cell rango-summary__cell--normal">
                              <div class="rango-summary__label">NORMAL (OPERACION)</div>
                              <div class="rango-summary__sub">Entre</div>
                              <div class="rango-summary__value">{{ formatRangoNum(rangoBarSaved.normal.lower) }} {{ rangoUnidad }} &mdash; {{ formatRangoNum(rangoBarSaved.normal.upper) }} {{ rangoUnidad }}</div>
                            </div>
                            <div v-if="rangoBarSaved.advAlta" class="rango-summary__cell rango-summary__cell--adv">
                              <div class="rango-summary__label">ADVERTENCIA SUPERIOR</div>
                              <div class="rango-summary__sub">Entre</div>
                              <div class="rango-summary__value">{{ formatRangoNum(rangoBarSaved.advAlta.lower) }} {{ rangoUnidad }} &mdash; {{ formatRangoNum(rangoBarSaved.advAlta.upper) }} {{ rangoUnidad }}</div>
                            </div>
                            <div v-if="rangoBarSaved.alarmaAlta" class="rango-summary__cell rango-summary__cell--alarma">
                              <div class="rango-summary__label">ALARMA ALTA</div>
                              <div class="rango-summary__sub">Mayor que</div>
                              <div class="rango-summary__value">{{ formatRangoNum(rangoBarSaved.alarmaAlta.lower) }} {{ rangoUnidad }}</div>
                            </div>
                          </div>
                        </div>
                      </v-col>

                      <!-- ============================================
                           VISTA CREATE/EDIT: form fields
                           ============================================ -->

                      <!-- Steps mini-indicator -->
                      <v-col v-if="rangoEstadoVista === 'create' || rangoEstadoVista === 'edit'" cols="12">
                        <div class="rango-mini-steps">
                          <div class="rango-mini-step">
                            <span class="rango-mini-step__num rango-mini-step__num--green">1</span>
                            <span class="rango-mini-step__label">Define el rango normal (operacion).</span>
                          </div>
                          <div class="rango-mini-step">
                            <span class="rango-mini-step__num rango-mini-step__num--amber">2</span>
                            <span class="rango-mini-step__label">Define el margen de advertencia.</span>
                          </div>
                          <div class="rango-mini-step rango-mini-step--info">
                            El sistema calculara automaticamente las zonas de alarma.
                          </div>
                        </div>
                      </v-col>

                      <!-- 2 cards: NORMAL + ADVERTENCIA -->
                      <v-col v-if="rangoEstadoVista === 'create' || rangoEstadoVista === 'edit'" cols="12">
                        <div class="rango-cards">
                          <article class="rango-card rango-card--normal">
                            <header class="rango-card__head">
                              <span class="rango-card__step">1</span>
                              <div class="rango-card__title">RANGO NORMAL (OPERACION)</div>
                            </header>
                            <p class="rango-card__hint">Valores esperados durante la operacion normal de la maquina.</p>
                            <div class="rango-card__fields">
                              <v-text-field
                                v-model="rangoVariableForm.normalMin"
                                label="Desde (minimo normal)"
                                type="number"
                                outlined
                                dense
                                hide-spin-buttons
                                :suffix="rangoUnidad"
                                :disabled="savingRangoVariable || !rangoVariableTargetId"
                                :error-messages="erroresRangoVariableForm.normalMin"
                                @focus="erroresRangoVariableForm.normalMin = null"
                              ></v-text-field>
                              <v-text-field
                                v-model="rangoVariableForm.normalMax"
                                label="Hasta (maximo normal)"
                                type="number"
                                outlined
                                dense
                                hide-spin-buttons
                                :suffix="rangoUnidad"
                                :disabled="savingRangoVariable || !rangoVariableTargetId"
                                :error-messages="erroresRangoVariableForm.normalMax"
                                @focus="erroresRangoVariableForm.normalMax = null"
                              ></v-text-field>
                            </div>
                            <div class="rango-card__note rango-card__note--ok">
                              <v-icon small>mdi-check-circle-outline</v-icon>
                              Valores dentro de este rango se muestran en estado NORMAL (verde).
                            </div>
                          </article>

                          <article class="rango-card rango-card--warn">
                            <header class="rango-card__head">
                              <span class="rango-card__step">2</span>
                              <div class="rango-card__title">MARGEN DE ADVERTENCIA</div>
                            </header>
                            <p class="rango-card__hint">Variacion aceptable antes de generar una alarma.</p>
                            <div class="rango-card__fields">
                              <v-text-field
                                v-model="rangoVariableForm.advertenciaMin"
                                label="Limite inferior (minimo aceptable)"
                                type="number"
                                outlined
                                dense
                                hide-spin-buttons
                                :suffix="rangoUnidad"
                                :disabled="savingRangoVariable || !rangoVariableTargetId"
                                :error-messages="erroresRangoVariableForm.advertenciaMin"
                                @focus="erroresRangoVariableForm.advertenciaMin = null"
                              ></v-text-field>
                              <v-text-field
                                v-model="rangoVariableForm.advertenciaMax"
                                label="Limite superior (maximo aceptable)"
                                type="number"
                                outlined
                                dense
                                hide-spin-buttons
                                :suffix="rangoUnidad"
                                :disabled="savingRangoVariable || !rangoVariableTargetId"
                                :error-messages="erroresRangoVariableForm.advertenciaMax"
                                @focus="erroresRangoVariableForm.advertenciaMax = null"
                              ></v-text-field>
                            </div>
                            <div class="rango-card__note rango-card__note--warn">
                              <v-icon small>mdi-alert-outline</v-icon>
                              Valores entre este margen y el rango normal se muestran en ADVERTENCIA (amarillo).
                            </div>
                          </article>
                        </div>
                      </v-col>

                      <!-- Vista previa de los rangos (bar) -->
                      <v-col v-if="(rangoEstadoVista === 'create' || rangoEstadoVista === 'edit') && rangoBarVisible" cols="12">
                        <div class="rango-preview">
                          <div class="rango-preview__head">
                            <v-icon small>mdi-eye-outline</v-icon>
                            VISTA PREVIA DE LOS RANGOS
                          </div>

                          <div class="rango-bar-legend">
                            <div v-if="rangoBar.alarmaBaja" class="rango-bar-legend__item rango-bar-legend__item--alarma">
                              <div class="rango-bar-legend__title">ALARMA</div>
                              <div class="rango-bar-legend__range">(&lt; {{ formatRangoNum(rangoBar.alarmaBaja.upper) }} {{ rangoUnidad }})</div>
                            </div>
                            <div v-if="rangoBar.advBaja" class="rango-bar-legend__item rango-bar-legend__item--adv">
                              <div class="rango-bar-legend__title">ADVERTENCIA</div>
                              <div class="rango-bar-legend__range">({{ formatRangoNum(rangoBar.advBaja.lower) }} - {{ formatRangoNum(rangoBar.advBaja.upper) }} {{ rangoUnidad }})</div>
                            </div>
                            <div class="rango-bar-legend__item rango-bar-legend__item--normal">
                              <div class="rango-bar-legend__title">NORMAL</div>
                              <div class="rango-bar-legend__range">({{ formatRangoNum(rangoBar.normal.lower) }} - {{ formatRangoNum(rangoBar.normal.upper) }} {{ rangoUnidad }})</div>
                            </div>
                            <div v-if="rangoBar.advAlta" class="rango-bar-legend__item rango-bar-legend__item--adv">
                              <div class="rango-bar-legend__title">ADVERTENCIA</div>
                              <div class="rango-bar-legend__range">({{ formatRangoNum(rangoBar.advAlta.lower) }} - {{ formatRangoNum(rangoBar.advAlta.upper) }} {{ rangoUnidad }})</div>
                            </div>
                            <div v-if="rangoBar.alarmaAlta" class="rango-bar-legend__item rango-bar-legend__item--alarma">
                              <div class="rango-bar-legend__title">ALARMA</div>
                              <div class="rango-bar-legend__range">(&gt; {{ formatRangoNum(rangoBar.alarmaAlta.lower) }} {{ rangoUnidad }})</div>
                            </div>
                          </div>

                          <div class="rango-bar">
                            <div
                              v-for="(seg, i) in rangoBar.segments"
                              :key="'seg-' + i"
                              class="rango-bar__seg"
                              :class="'rango-bar__seg--' + seg.kind"
                              :style="{ flex: seg.flex }"
                            ></div>
                          </div>
                          <div class="rango-bar-axis">
                            <span v-for="(tick, i) in rangoBar.ticks" :key="'tick-' + i" class="rango-bar-axis__tick" :style="{ left: tick.pos + '%' }">
                              {{ formatRangoNum(tick.value) }}
                            </span>
                          </div>
                        </div>
                      </v-col>

                      <!-- Resumen de configuracion -->
                      <v-col v-if="(rangoEstadoVista === 'create' || rangoEstadoVista === 'edit') && rangoBarVisible" cols="12">
                        <div class="rango-summary">
                          <div class="rango-summary__head">
                            <v-icon small>mdi-clipboard-text-outline</v-icon>
                            RESUMEN DE CONFIGURACION
                          </div>
                          <div class="rango-summary__grid">
                            <div v-if="rangoBar.alarmaBaja" class="rango-summary__cell rango-summary__cell--alarma">
                              <div class="rango-summary__label">ALARMA BAJA</div>
                              <div class="rango-summary__sub">Menor que</div>
                              <div class="rango-summary__value">{{ formatRangoNum(rangoBar.alarmaBaja.upper) }} {{ rangoUnidad }}</div>
                            </div>
                            <div v-if="rangoBar.advBaja" class="rango-summary__cell rango-summary__cell--adv">
                              <div class="rango-summary__label">ADVERTENCIA INFERIOR</div>
                              <div class="rango-summary__sub">Entre</div>
                              <div class="rango-summary__value">{{ formatRangoNum(rangoBar.advBaja.lower) }} {{ rangoUnidad }} &mdash; {{ formatRangoNum(rangoBar.advBaja.upper) }} {{ rangoUnidad }}</div>
                            </div>
                            <div class="rango-summary__cell rango-summary__cell--normal">
                              <div class="rango-summary__label">NORMAL (OPERACION)</div>
                              <div class="rango-summary__sub">Entre</div>
                              <div class="rango-summary__value">{{ formatRangoNum(rangoBar.normal.lower) }} {{ rangoUnidad }} &mdash; {{ formatRangoNum(rangoBar.normal.upper) }} {{ rangoUnidad }}</div>
                            </div>
                            <div v-if="rangoBar.advAlta" class="rango-summary__cell rango-summary__cell--adv">
                              <div class="rango-summary__label">ADVERTENCIA SUPERIOR</div>
                              <div class="rango-summary__sub">Entre</div>
                              <div class="rango-summary__value">{{ formatRangoNum(rangoBar.advAlta.lower) }} {{ rangoUnidad }} &mdash; {{ formatRangoNum(rangoBar.advAlta.upper) }} {{ rangoUnidad }}</div>
                            </div>
                            <div v-if="rangoBar.alarmaAlta" class="rango-summary__cell rango-summary__cell--alarma">
                              <div class="rango-summary__label">ALARMA ALTA</div>
                              <div class="rango-summary__sub">Mayor que</div>
                              <div class="rango-summary__value">{{ formatRangoNum(rangoBar.alarmaAlta.lower) }} {{ rangoUnidad }}</div>
                            </div>
                          </div>
                        </div>
                      </v-col>

                      <v-col v-if="erroresRangoVariableForm._general" cols="12">
                        <v-alert
                          type="error"
                          text
                          dense
                          border="left"
                          icon="mdi-alert-circle-outline"
                          class="mb-0"
                          @input="erroresRangoVariableForm._general = null"
                          dismissible
                        >
                          {{ erroresRangoVariableForm._general }}
                        </v-alert>
                      </v-col>

                      <!-- Botones al fondo (Guardar / Cancelar) -->
                      <v-col v-if="rangoEstadoVista === 'create' || rangoEstadoVista === 'edit'" cols="12" class="rango-footer-actions">
                        <v-btn
                          v-if="rangoEstadoVista === 'edit'"
                          text
                          color="blue darken-1"
                          :disabled="savingRangoVariable"
                          @click="resetRangoVariableForm"
                        >
                          <v-icon left small>mdi-close</v-icon>
                          Cancelar edicion
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="(rangoEstadoVista === 'edit' && permisoVista('maquinas','u')) || (rangoEstadoVista === 'create' && permisoVista('maquinas','c'))"
                          color="orange darken-2"
                          dark
                          large
                          :loading="savingRangoVariable"
                          :disabled="savingRangoVariable || !rangoVariableTargetId"
                          @click="saveRangoVariable"
                        >
                          <v-icon left>mdi-content-save-outline</v-icon>
                          {{ rangoEstadoVista === 'edit' ? 'Actualizar rango' : 'Guardar rango' }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" class="machine-setup-tokens-panel">
                <v-card class="machine-setup-panel" outlined>
                  <v-card-title class="machine-setup-panel__title">
                    <div>
                      <div class="machine-setup-panel__eyebrow">Paso 1</div>
                      <div>Tokens asignados</div>
                    </div>
                    <v-chip small color="blue lighten-5" text-color="blue darken-2">
                      {{ tokensAsignados.length }}
                    </v-chip>
                  </v-card-title>
                  <v-card-text class="token-setup">
                    <!-- 1. Seleccionar token -->
                    <div class="token-step">
                      <div class="token-step__head">
                        <span class="token-step__num">1</span>
                        <span class="token-step__title">Seleccionar token</span>
                      </div>
                      <v-row class="mt-1">
                        <v-col cols="12" md="9">
                          <v-autocomplete
                            v-model="tokenMaquinaForm.idToken"
                            :items="tokensCatalogo"
                            item-text="token"
                            item-value="idToken"
                            label="Buscar token por codigo o descripcion..."
                            outlined
                            dense
                            hide-details="auto"
                            prepend-inner-icon="mdi-magnify"
                            :loading="loadingTokensCatalogo"
                            :disabled="savingTokenAsignacion || loadingTokensCatalogo || maquinaYaTieneToken"
                            :error-messages="erroresTokenForm.idToken"
                            @focus="erroresTokenForm.idToken = null"
                          >
                            <template v-slot:item="data">
                              <v-list-item-content>
                                <v-list-item-title>{{ data.item.token }}</v-list-item-title>
                                <v-list-item-subtitle>
                                  {{ data.item.tipoToken || 'N/A' }} | {{ data.item.descripcion || 'Sin descripcion' }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="3" class="d-flex align-start">
                          <v-btn
                            v-if="permisoVista('maquinas','c')"
                            color="primary"
                            block
                            :loading="savingTokenAsignacion"
                            :disabled="savingTokenAsignacion || !maquinaAsignacion || !tokenMaquinaForm.idToken || maquinaYaTieneToken"
                            @click="asignarToken"
                          >
                            Asignar
                          </v-btn>
                        </v-col>
                        <v-col cols="12" class="pt-0">
                          <v-alert dense text :type="maquinaYaTieneToken ? 'warning' : 'info'" class="mb-0">
                            <template v-if="maquinaYaTieneToken">
                              Esta máquina ya tiene un token activo. Para asignar otro, primero desactiva el actual en el paso 2.
                            </template>
                            <template v-else>
                              Solo puedes asignar un token por máquina. Si la máquina ya tiene uno activo, primero debes desactivarlo.
                            </template>
                          </v-alert>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- 2. Token actualmente asignado -->
                    <div class="token-step">
                      <div class="token-step__head">
                        <span class="token-step__num">2</span>
                        <span class="token-step__title">Token actualmente asignado</span>
                      </div>
                      <div v-if="tokenActivoAsignado" class="token-active-card">
                        <div class="token-active-card__main">
                          <v-icon color="success" class="mr-3">mdi-key-wireless</v-icon>
                          <div>
                            <div class="token-active-card__name">{{ tokenActivoAsignado.token }}</div>
                            <div class="token-active-card__desc">{{ tokenActivoAsignado.descripcionToken || 'Sin descripcion' }}</div>
                          </div>
                        </div>
                        <div class="token-active-card__meta">
                          <div class="token-meta">
                            <span class="token-meta__label">Tipo</span>
                            <span>{{ tokenActivoAsignado.tipoToken || 'N/A' }}</span>
                          </div>
                          <div class="token-meta">
                            <span class="token-meta__label">Asignado el</span>
                            <span>{{ formatFechaHora(tokenActivoAsignado.fechaInicio) }}</span>
                          </div>
                          <div class="token-meta">
                            <span class="token-meta__label">Estado</span>
                            <v-chip x-small color="green lighten-4" text-color="green darken-2">Activo</v-chip>
                          </div>
                        </div>
                        <v-btn
                          v-if="permisoVista('maquinas','d')"
                          outlined
                          color="red darken-1"
                          :loading="deletingTokenAsignacionId === tokenActivoAsignado.idTokenMaquina"
                          :disabled="savingTokenAsignacion"
                          @click="deleteTokenAsignacion(tokenActivoAsignado)"
                        >
                          <v-icon left small>mdi-close-circle-outline</v-icon>
                          Desactivar
                        </v-btn>
                      </div>
                      <v-alert v-else dense text type="warning" class="mb-0">
                        Esta maquina no tiene un token asignado actualmente.
                      </v-alert>
                    </div>

                    <!-- 3. Historial de asignaciones -->
                    <div class="token-step">
                      <div class="token-step__head">
                        <span class="token-step__num">3</span>
                        <span class="token-step__title">Historial de asignaciones</span>
                      </div>
                      <v-data-table
                        :headers="headersHistorialTokens"
                        :items="tokensHistorialMaquina"
                        :loading="loadingTokensAsignados"
                        loading-text="Cargando asignaciones..."
                        no-data-text="No hay asignaciones registradas para esta maquina."
                        dense
                        class="machine-setup-table"
                      >
                        <template v-slot:[`item.token`]="{ item }">
                          <div class="vc-cell">
                            <div class="vc-cell__title">{{ item.token }}</div>
                            <div class="token-history__desc">{{ item.descripcionToken || 'Sin descripcion' }}</div>
                          </div>
                        </template>
                        <template v-slot:[`item.condicion`]="{ item }">
                          <v-chip
                            small
                            :color="item.condicion === false ? 'red lighten-4' : 'green lighten-4'"
                            :text-color="item.condicion === false ? 'red darken-2' : 'green darken-2'"
                          >
                            {{ item.condicion === false ? 'Inactivo' : 'Activo' }}
                          </v-chip>
                        </template>
                        <template v-slot:[`item.fechaInicio`]="{ item }">
                          {{ formatFechaHora(item.fechaInicio) }}
                        </template>
                        <template v-slot:[`item.fechaFin`]="{ item }">
                          {{ item.fechaFin ? formatFechaHora(item.fechaFin) : '—' }}
                        </template>
                      </v-data-table>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" class="machine-setup-variables-panel">
                <v-card class="machine-setup-panel" outlined>
                  <v-card-title class="machine-setup-panel__title">
                    <div>
                      <div class="machine-setup-panel__eyebrow">Paso 2</div>
                      <div>Variables conectadas</div>
                    </div>
                    <v-chip small color="teal lighten-5" text-color="teal darken-2">
                      {{ variablesConectadasActivas.length }}
                    </v-chip>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="8">
                        <v-autocomplete
                          v-model="maquinaSensorVariableForm.idSensorVariable"
                          :items="sensorVariablesDisponibles"
                          item-text="sensorVariableLabel"
                          item-value="idSensorVariable"
                          item-disabled="asignacionBloqueada"
                          label="Relacion sensor-variable"
                          outlined
                          dense
                          prepend-inner-icon="mdi-graph-outline"
                          :loading="loadingSensorVariablesCatalogo"
                          :disabled="savingMaquinaSensorVariable || loadingSensorVariablesCatalogo"
                          :error-messages="erroresMaquinaSensorVariableForm.idSensorVariable"
                          @focus="erroresMaquinaSensorVariableForm.idSensorVariable = null"
                        >
                          <template v-slot:item="data">
                            <v-list-item-content>
                              <v-list-item-title>{{ data.item.sensorVariableLabel }}</v-list-item-title>
                              <v-list-item-subtitle>
                                {{ data.item.sensorNombre || 'N/A' }} | {{ data.item.variableCodigo || 'N/A' }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" class="d-flex justify-end align-center">
                        <v-btn
                          v-if="permisoVista('maquinas','c')"
                          color="teal darken-1"
                          dark
                          :loading="savingMaquinaSensorVariable"
                          :disabled="savingMaquinaSensorVariable || !maquinaAsignacion || sensorVariableDuplicadaEnToken"
                          @click="saveMaquinaSensorVariable"
                        >
                          Agregar
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        <v-data-table
                          :headers="headersVariablesConectadas"
                          :items="maquinaSensorVariables"
                          :loading="loadingMaquinaSensorVariables"
                          loading-text="Cargando asignaciones..."
                          no-data-text="No hay relaciones sensor-variable asignadas para esta maquina."
                          dense
                          class="machine-setup-table"
                        >
                          <template v-slot:[`item.sensorLabel`]="{ item }">
                            <div class="vc-cell">
                              <div class="vc-cell__title">{{ item.sensorLabel }}</div>
                              <v-chip v-if="item.sensorCodigo" x-small outlined color="primary" class="vc-cell__chip">
                                {{ item.sensorCodigo }}
                              </v-chip>
                            </div>
                          </template>
                          <template v-slot:[`item.variableLabel`]="{ item }">
                            <div class="vc-cell">
                              <div class="vc-cell__title">{{ item.variableLabel }}</div>
                              <v-chip v-if="item.variableCodigo" x-small outlined color="teal" class="vc-cell__chip">
                                {{ item.variableCodigo }}
                              </v-chip>
                            </div>
                          </template>
                          <template v-slot:[`item.condicion`]="{ item }">
                            <v-chip
                              small
                              :color="item.condicion === false ? 'red lighten-4' : 'green lighten-4'"
                              :text-color="item.condicion === false ? 'red darken-2' : 'green darken-2'"
                            >
                              {{ item.condicion === false ? 'Inactiva' : 'Activa' }}
                            </v-chip>
                          </template>
                          <template v-slot:[`item.rangosConfigurados`]="{ item }">
                            <div class="vc-rangos">
                              <div class="vc-rangos__count">
                                <v-icon
                                  small
                                  :color="item.rangosConfigurados > 0 ? 'green darken-1' : 'grey'"
                                >
                                  {{ item.rangosConfigurados > 0 ? 'mdi-check-circle-outline' : 'mdi-circle-outline' }}
                                </v-icon>
                                <span class="ml-1">{{ item.rangosConfigurados || 0 }} rango{{ item.rangosConfigurados === 1 ? '' : 's' }}</span>
                              </div>
                            </div>
                          </template>
                          <template v-slot:[`item.fechaInicio`]="{ item }">
                            {{ formatFechaHora(item.fechaInicio) }}
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <div class="vc-actions">
                              <v-tooltip bottom color="black" class="white--text">
                                <template v-slot:activator="{ on }">
                                  <div v-on="on" class="d-inline-flex">
                                    <v-switch
                                      :key="'vc-sw-' + item.idMaquinaSensorVariable + '-' + vcSwitchNonce"
                                      :input-value="item.condicion !== false"
                                      :loading="deletingMaquinaSensorVariableId === item.idMaquinaSensorVariable"
                                      :disabled="deletingMaquinaSensorVariableId === item.idMaquinaSensorVariable || savingMaquinaSensorVariable || !permisoVista('maquinas','d')"
                                      color="success"
                                      dense
                                      hide-details
                                      inset
                                      class="estado-switch"
                                      @change="toggleVariableConectada(item)"
                                    ></v-switch>
                                  </div>
                                </template>
                                <span class="white--text">{{ item.condicion === false ? 'Activar variable conectada' : 'Desactivar variable conectada' }}</span>
                              </v-tooltip>
                            </div>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

            </v-row>
          </v-card-text>
          <v-card-actions class="machine-setup-dialog__footer">
            <div class="machine-setup-dialog__footer-note">
              Configura tokens y variables desde un solo lugar para dejar la maquina totalmente enlazada.
            </div>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeConfiguracionMaquina">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogRangoVariableEstado" max-width="520px" persistent>
        <v-card class="rango-status-dialog">
          <v-card-title class="rango-status-dialog__title">
            <v-icon
              class="mr-3"
              :color="rangoVariableEstadoDialogActivar ? 'green darken-2' : 'orange darken-2'"
            >
              {{ rangoVariableEstadoDialogActivar ? 'mdi-check-circle-outline' : 'mdi-alert' }}
            </v-icon>
            <span>{{ rangoVariableEstadoDialogTitle }}</span>
            <v-spacer></v-spacer>
            <v-btn icon small :disabled="togglingRangoVariableId != null" @click="closeRangoVariableEstadoDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <p class="rango-status-dialog__copy">
              {{ rangoVariableEstadoDialogCopy }}
            </p>

            <div class="rango-status-dialog__variable">
              <div class="rango-status-dialog__variable-icon">
                <v-icon color="blue darken-2">mdi-sine-wave</v-icon>
              </div>
              <div>
                <div class="rango-status-dialog__variable-label">Variable:</div>
                <div class="rango-status-dialog__variable-value">
                  {{ rangoVariableEstadoDialogVariableLabel }}
                </div>
              </div>
            </div>

            <v-alert
              dense
              text
              :type="rangoVariableEstadoDialogAlertType"
              class="rango-status-dialog__alert"
            >
              {{ rangoVariableEstadoDialogAlert }}
            </v-alert>
          </v-card-text>
          <v-card-actions class="rango-status-dialog__actions">
            <v-spacer></v-spacer>
            <v-btn
              outlined
              color="blue-grey darken-1"
              :disabled="togglingRangoVariableId != null"
              @click="closeRangoVariableEstadoDialog"
            >
              Cancelar
            </v-btn>
            <v-btn
              :color="rangoVariableEstadoDialogActivar ? 'success' : 'error'"
              dark
              :loading="togglingRangoVariableId === rangoVariableEstadoDialogItemId"
              :disabled="!rangoVariableEstadoDialogItem"
              @click="confirmRangoVariableEstado"
            >
              <v-icon left small>
                {{ rangoVariableEstadoDialogActivar ? 'mdi-check-circle-outline' : 'mdi-pause-circle-outline' }}
              </v-icon>
              {{ rangoVariableEstadoDialogButtonText }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog
			v-model="cargaMasiva"
			persistent
			max-width="500px"
			key="cargaMasiva"
		>
			<v-card>
				<v-card-title
					>Carga Masiva de Inventario</v-card-title
				>
				<v-card-text v-if="errorCargaMasiva">
					<v-col cols="12" md="12" sm="12" class="text-center">
						<h5>Se ha producido un error. Intente una vez más.</h5>
					</v-col>
					<v-col cols="12" md="12" sm="12" class="text-center">
						<v-btn
							depressed
							color="red"
							text
							@click="
								cargaMasiva = false;
								ficheroCarga = null;
								cargaCargaCompleta = false;
								loadingCargaMasiva = false;
								errorCargaMasiva = false;
								selectedUpdateFile = null;
							"
							>Cerrar</v-btn
						>
					</v-col>
				</v-card-text>
				<v-card-text v-if="cargaCargaCompleta">
					<v-col cols="12" md="12" sm="12" class="text-center">
						<!-- errores -->
            <h4 v-if="erroresCarga.length <= 0">Carga Realizada Correctamente</h4>
            <h4 v-else>Uno o varios errores al intentar la cargar</h4>
            <template v-if="erroresCarga.length > 0">
              <template v-for="(item, index) in erroresCarga">
                <p class="mb-1" :key="index" style="font-size: 16px !important">
                  <v-icon color="red">mdi-alert-circle-outline</v-icon> {{item}}
                </p>
                <v-divider :key="`divider-${index}`" />
              </template>
            </template>
					</v-col>
					<v-col cols="12" md="12" sm="12" class="text-center">
						<v-btn
							depressed
							color="success"
							text
							@click="
								cargaMasiva = false;
								ficheroCarga = null;
								cargaCargaCompleta = false;
								loadingCargaMasiva = false;
								errorCargaMasiva = false;
								selectedUpdateFile = null;
							"
							>Cerrar</v-btn
						>
					</v-col>
				</v-card-text>
				<v-card-text v-if="loadingCargaMasiva && !cargaCargaCompleta">
					<v-col cols="12" md="12" sm="12" class="text-center">
						<h4>Cargando</h4>
					</v-col>
					<v-col cols="12" md="12" sm="12" class="text-center">
						<v-progress-circular
							:size="75"
							color="green"
							indeterminate
						></v-progress-circular>
					</v-col>
				</v-card-text>
				<v-card-text
					v-if="
						!loadingCargaMasiva &&
						!cargaCargaCompleta &&
						!errorCargaMasiva
					"
					class="text-center"
				>
					<v-file-input
						v-model="ficheroCarga"
						accept=".csv"
						@change="cambioficheroCompras"
						show-size
						label="Fichero Carga .CSV"
					></v-file-input>

					<br />
					<br />
					<v-row>
						
						<v-btn
							color="blue darken-1"
							text
							@click="
								cargaMasiva = false;
								ficheroCarga = null;
								cargaCargaCompleta = false;
								loadingCargaMasiva = false;
								errorCargaMasiva = false;
								selectedUpdateFile = null;
							"
							>Cancelar</v-btn
						>
						<v-btn
							color="red darken-1"
							text
							@click="cargaMasivaPost"
							>Aceptar</v-btn
						>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
    <v-snackbar
      v-model="alerta"
      top
      color="error"
    >
      Existe una Máquina/Herramienta Activa con el mismo código/numero de serie
      <v-btn
        text
        @click="alerta = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="dialogReactivarToken" max-width="480px">
      <v-card>
        <v-card-title class="headline">
          <v-icon color="primary" left>mdi-help-circle-outline</v-icon>
          Reactivar asignación existente
        </v-card-title>
        <v-card-text>
          <p class="mb-2">
            Ya existe una asignación previa entre esta máquina y el token
            <strong>{{ reactivarTokenInfo ? reactivarTokenInfo.token : '' }}</strong>,
            pero actualmente se encuentra inactiva.
          </p>
          <p class="mb-2">¿Deseas reactivar esta asignación?</p>
          <v-alert dense text type="info" class="mb-0">
            Se reactivará la asignación y el token quedará activo para esta máquina.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelarReactivarToken">Cancelar</v-btn>
          <v-btn color="primary" :loading="savingTokenAsignacion" @click="confirmarReactivarToken">Reactivar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogVariableConectadaBloqueada" max-width="560px" persistent>
      <v-card>
        <v-card-title class="headline error--text vc-bloqueo-title">
          <v-icon color="error" left>mdi-alert-circle-outline</v-icon>
          <span>No es posible desactivar esta variable conectada</span>
        </v-card-title>
        <v-card-text>
          <p class="mb-2">
            La relación <strong>{{ variableConectadaBloqueadaLabel() }}</strong> ya tiene rangos configurados.
            Primero deben desactivarse los rangos asociados.
          </p>
          <div class="subtitle-2 mb-1">
            Rangos activos ({{ variableConectadaBloqueadaRangos.length }}):
          </div>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Advertencia mín.</th>
                  <th class="text-left">Normal mín.</th>
                  <th class="text-left">Normal máx.</th>
                  <th class="text-left">Advertencia máx.</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="rango in variableConectadaBloqueadaRangos" :key="rango.idRango">
                  <td>{{ formatRangoNum(rango.advertenciaMin) }}</td>
                  <td>{{ formatRangoNum(rango.normalMin) }}</td>
                  <td>{{ formatRangoNum(rango.normalMax) }}</td>
                  <td>{{ formatRangoNum(rango.advertenciaMax) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeVariableConectadaBloqueada">Cerrar</v-btn>
          <v-btn color="orange darken-2" text @click="irAConfigurarRangosBloqueados">
            Ir a configurar rangos
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTokensExtras" max-width="750px">
      <v-card>
        <v-card-title class="headline">Tokens Extras</v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    Valor
                  </th>
                  <th class="text-center">
                    Token
                  </th>
                  <th class="text-center">
                    Posicion
                  </th>
                  <th class="text-center">
                    Tipo
                  </th>
                  <th class="text-center">
                    Activo
                  </th>
                  <th class="text-center">
                    Virtual
                  </th>
                  <th class="text-center">
                    condición
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, x) in editedItem.tokensExtras"
                  :key="x"
                >
                <td>
                  <v-text-field
                  v-model="item.valor"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                  v-model="item.token"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                  v-model="item.posicion"
                  type="number"
                  :min="0"
                  step="1"
                  ></v-text-field>
                </td>
                <td>
                  <v-select
                  :items="tiposTokens"
                  v-model="item.tipo"
                  item-text="text"
                  item-value="id"
                  ></v-select>
                </td>
                  <td>
                    <v-switch
      v-model="item.activo"
    ></v-switch>
                  </td>
                  <td>
                    <v-switch
      v-model="item.multiplicador"
    ></v-switch>
                  </td>
                  <td>
                    <v-tooltip bottom color="black" class="white--text">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on"
                          small
                          @click="eliminarTokenExtra(item.idTokenExtra)"
                        >
                          delete
                        </v-icon>
                      </template>
                      <span class="white--text">Eliminar</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-btn block color="primary" @click="NuevoitemToken()">
            Agregar nuevo token
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogTokensExtras = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import axios from "axios";
import InputToken from './InputToken.vue';
import DownloadBtn from '@/components/DownloadBtn.vue';
import { mapState } from "vuex"
import moment from "moment";
import VAutocompleteTextfield from '../../VAutocompleteTextfield.vue';
import MenuDatepicker from '../../MenuDatepicker.vue';

  export default {
    components: {
      InputToken,
      DownloadBtn,
      VAutocompleteTextfield,
      MenuDatepicker
    },
    data: () => ({
      indexToken: 0,
      dialogTokensExtras: false,
      dialogAsignacionTokens: false,
      dialogAsignacionSensorVariables: false,
      dialogConfiguracionMaquina: false,
      loadingKilometrajeActual: false,
      loadingMotoresMontacargas: false,
      motoresMontacargas: [],
      loadingAgencias: false,
      agencias: [],
      loadingModificaciones: false,
      modificaciones: [],
      tiposTransporte: [
        {
          text: "UTILITARIA",
          value: 1
        },
        {
          text: "MERCANTIL",
          value: 2
        }
      ],
      tiposCategorias: ['bascula','montacargas','transporte'],
      tiposBascula: [
        {
          text: "PLATO O PLATAFORMA",
          value: 1
        },
        {
          text: "MODULO",
          value: 2
        }
      ],
      loadingUsuarios: false,
      loadingTiposSensores: false,
      loadingSensoresAsignados: false,
      loadingRangosSensores: false,
      savingSensorAsignacion: false,
      savingSensorRango: false,
      deletingSensorAsignacionId: null,
      deletingSensorRangoId: null,
      loadingTokensCatalogo: false,
      loadingTokensAsignados: false,
      savingTokenAsignacion: false,
      deletingTokenAsignacionId: null,
      tokensHistorialMaquina: [],
      dialogReactivarToken: false,
      reactivarTokenInfo: null,
      loadingSensorVariablesCatalogo: false,
      loadingMaquinaSensorVariables: false,
      savingMaquinaSensorVariable: false,
      deletingMaquinaSensorVariableId: null,
      dialogVariableConectadaBloqueada: false,
      variableConectadaBloqueadaItem: null,
      variableConectadaBloqueadaRangos: [],
      vcSwitchNonce: 0,
      loadingRangosVariables: false,
      savingRangoVariable: false,
      togglingRangoVariableId: null,
      dialogRangoVariableEstado: false,
      rangoVariableEstadoDialogItem: null,
      showRangosGuardados: false,
      usuarios: [],
      ubicaciones: [],
      erroresItem: {
        errorNumSerie: null,
        errorAlcanceMaxMed: null,
        errorEsMaquina: null,
        erroridMaquinaCategoria: null,
        erroridArea: null,
        erroridMaquina: null,
        errornombre: null,
        errorfechaFabricacion: null,
        errorfechaCompra: null,
        errortoken: null,
        errortoken2: null,
        errorCapacidad: null,
        errorMotor: null,
        errorNumCilindros: null,
        errorMastilEtapas: null,
        errorUsuario: null,
        errorTipoBascula: null,
        errorUbicacion: null,
        errorTipoTransporte: null,
        errorVersion: null,
        errorPlacas: null,
        errorNumMotor: null
      },
      erroresSensorForm: {
        idTipoSensor: null,
        tokenDispositivo: null,
        descripcion: null
      },
      erroresSensorRangoForm: {
        cantidadMuestras: null,
        desviacionInferior: null,
        desviacionSuperior: null
      },
      erroresTokenForm: {
        idToken: null
      },
      erroresMaquinaSensorVariableForm: {
        idSensorVariable: null
      },
      erroresRangoVariableForm: {
        normalMin: null,
        normalMax: null,
        advertenciaMin: null,
        advertenciaMax: null,
        _general: null
      },
      chkey: 0,
      saving: false,
      tipos:[
        {
          name:'Máquina',
          value:true
        },
        {
          name:'Herramienta',
          value:false
        }
      ],
      loadingCatMaquinas: false,
      catMaquinas: [],
      loadingHabilidades: false,
      habilidades: [],
      loadingOperador: false,
      personas: [],
      alerta:false,
      imagenVistaPrevia: '',
      imagenArchivo: null,
      dialogAddImg: false,
      dialogImg: false,
      areas:[],
      erroresCarga:[],
      defaultImagen:{
        img: '',
        ruta: '',
        idImagen: '',
        descripcion: 'Cargando... Espere por Favor',
      },
      imagen: {
        img: '',
        ruta: '',
        idImagen: '',
        descripcion: 'Cargando... Espere por Favor',
      },
      loadingArea: false,
      dialog: false,
      eliminar: false,
      view: false,
      search: '',
      headers: [
        {
          text: 'Tipo',
          align: 'left',
          sortable: true,
          value: 'tipo',
        },
        {
          text: 'Área',
          align: 'left',
          sortable: true,
          value: 'area',
        },
        {
          text: 'Categoría',
          align: 'left',
          sortable: true,
          value: 'categoria',
        },
        {
          text: 'Grupo',
          align: 'left',
          sortable: true,
          value: 'maquinaTipo',
        },
        {
          text: 'Nombre/Código',
          align: 'left',
          sortable: true,
          value: 'nombre',
        },
        {
          text: 'Marca',
          align: 'left',
          sortable: true,
          value: 'marca',
        },
        {
          text: 'Modelo',
          align: 'left',
          sortable: true,
          value: 'modelo',
        },
        {
          text: 'Descripción General',
          align: 'left',
          sortable: true,
          value: 'descripcionGeneral',
        },
        { text: 'Importancia', value: 'importancia', sortable: true, align:'center' },
        { text: 'Acciones', value: 'action', sortable: false, width:'22%', align:'center' },
      ],
      headersSensoresAsignados: [
        { text: 'Tipo de sensor', value: 'tipoSensor', sortable: true, align: 'left' },
        { text: 'Token', value: 'tokenDispositivo', sortable: true, align: 'left' },
        { text: 'Descripción', value: 'descripcion', sortable: true, align: 'left' },
        { text: 'Acciones', value: 'action', sortable: false, align: 'center', width: '12%' },
      ],
      headersTokensAsignados: [
        { text: 'Token', value: 'token', sortable: true, align: 'left' },
        { text: 'Tipo', value: 'tipoToken', sortable: true, align: 'left' },
        { text: 'Descripcion', value: 'descripcionToken', sortable: true, align: 'left' },
        { text: 'Acciones', value: 'action', sortable: false, align: 'center', width: '12%' },
      ],
      headersHistorialTokens: [
        { text: 'Token', value: 'token', sortable: true, align: 'left' },
        { text: 'Tipo', value: 'tipoToken', sortable: true, align: 'center' },
        { text: 'Estado', value: 'condicion', sortable: true, align: 'center' },
        { text: 'Fecha inicio', value: 'fechaInicio', sortable: true, align: 'center' },
        { text: 'Fecha fin', value: 'fechaFin', sortable: true, align: 'center' },
      ],
      headersMaquinaSensorVariables: [
        { text: 'Sensor', value: 'sensorLabel', sortable: true, align: 'left' },
        { text: 'Variable', value: 'variableLabel', sortable: true, align: 'left' },
        { text: 'Acciones', value: 'action', sortable: false, align: 'center', width: '12%' },
      ],
      headersVariablesConectadas: [
        { text: 'Sensor', value: 'sensorLabel', sortable: true, align: 'left' },
        { text: 'Variable', value: 'variableLabel', sortable: true, align: 'left' },
        { text: 'Estado', value: 'condicion', sortable: true, align: 'center' },
        { text: 'Rangos configurados', value: 'rangosConfigurados', sortable: true, align: 'center' },
        { text: 'Fecha asignación', value: 'fechaInicio', sortable: true, align: 'center' },
        { text: 'Acciones', value: 'action', sortable: false, align: 'center', width: '14%' },
      ],
      headersRangosVariables: [
        { text: 'Advert. min', value: 'advertenciaMin', sortable: true, align: 'left' },
        { text: 'Normal min', value: 'normalMin', sortable: true, align: 'left' },
        { text: 'Normal max', value: 'normalMax', sortable: true, align: 'left' },
        { text: 'Advert. max', value: 'advertenciaMax', sortable: true, align: 'left' },
        { text: 'Periodo', value: 'periodo', sortable: false, align: 'left' },
        { text: 'Estado', value: 'condicion', sortable: true, align: 'left' },
        { text: 'Acciones', value: 'action', sortable: false, align: 'center', width: '12%' },
      ],
      rangoVariableCampos: [
        { text: 'Normal min', value: 'normalMin' },
        { text: 'Normal max', value: 'normalMax' },
        { text: 'Advertencia min', value: 'advertenciaMin' },
        { text: 'Advertencia max', value: 'advertenciaMax' }
      ],
      headersSensorRangos: [
        { text: 'Sensor', value: 'sensorLabel', sortable: true, align: 'left' },
        { text: 'Cantidad muestras', value: 'nombre', sortable: true, align: 'left' },
        { text: 'Desviación inferior', value: 'descripcion', sortable: true, align: 'left' },
        { text: 'Desviación superior', value: 'maximo', sortable: true, align: 'left' },
        { text: 'Acciones', value: 'action', sortable: false, align: 'center', width: '12%' },
      ],
      loading: false,
      maquinas: [],
      maquinaAsignacion: null,
      tiposSensoresCatalogo: [],
      sensoresAsignados: [],
      sensorRangoTarget: null,
      sensorRangos: [],
      tokensCatalogo: [],
      tokensAsignados: [],
      sensorVariablesCatalogo: [],
      maquinaSensorVariables: [],
      maquinaSensorVariablesGlobal: [],
      rangoVariableTargetId: null,
      rangosVariables: [],
      sensorForm: {
        idSensor: null,
        idTipoSensor: null,
        tokenDispositivo: '',
        descripcion: ''
      },
      tokenMaquinaForm: {
        idTokenMaquina: null,
        idToken: null
      },
      maquinaSensorVariableForm: {
        idMaquinaSensorVariable: null,
        idSensorVariable: null
      },
      rangoVariableForm: {
        idRango: null,
        normalMin: '',
        normalMax: '',
        advertenciaMin: '',
        advertenciaMax: '',
        fechaInicio: '',
        fechaFin: ''
      },
      sensorRangoForm: {
        idRango: null,
        cantidadMuestras: '',
        desviacionInferior: '',
        desviacionSuperior: ''
      },
      delItem: '',
      action: 0,
      errores: [],
      erroresImagen:[],
      uploadImg:{
        idMaquina: '',
        mime: '',
        imagen:'',
        descripcion:'',
      },
      defaultUploadImg:{
        idMaquina: '',
        mime: '',
        imagen:'',
        descripcion:'',
      },
      viewedIndex: -1,
      viewedItem: null,
      editedIndex: -1,
      editedItem: null,
      defaultItem: {
        idArea:-1,
        idMaquina:-1,
        idUsuario: null,
        idMaquinaCategoria: null,
        idUbicacion: null,
        categoria: '',
        marca:'',
        modelo:'',
        numOperadores:0,
        descripcionGeneral:'',
        descripcionTecnica:'',
        costoHora:0.0,
        habilidades: [],
        numSerie: null,
        idMaquinaTipo: null,
        nombre: '',
        esMaquina:true,
        fechaFabricacion:null,
        fechaCompra:null,
        imagenes: [],
        token: "",
        token2: "",
        alcanceMaxMedicion: null,
        capacidad: null,
        motor: null,
        numCilindros: null,
        mastilEtapas: null,
        propuestaNuevaNomenclatura: null,
        tipoBascula: null,
        tipoTransporte: null,
        version: null,
        placas: null,
        numDeMotor: null,
        fechaVencimientoVerificacion: null,
        tarjetaMercantilVencimiento: null,
        kilometrajeActual: null,
        tokensExtras:null,
        importancia: 0,
      },
      categorias:[],
      loadingCategoria: false,
      clasificaciones:[],
      loadingClasificacion: false,
      cargaMasiva: false,
			ficheroCarga: null,
			cargaCargaCompleta: false,
			loadingCargaMasiva: false,
			errorCargaMasiva: false,
			selectedUpdateFile: null,
      tiposTokens:[{
        id:1,
        text:"Piezas Ok"
      },
      {
        id:2,
        text:"Piezas No Ok"
      }]
    }),

    computed: {
      ...mapState(["token","nombreEmpresa","sensoresTokenMaquina"]),
      esIndasa(){
        return this.nombreEmpresa.toUpperCase() == "INDASA";
      },
      computedHeaders(){
        let headers = this.headers.slice();
        if(this.esIndasa){
          let customHeader = headers.find(header => header.value == 'nombre');
          customHeader.text = 'Número Económico';
          headers = headers.filter((header) => header.value != 'tipo' && header.value != 'area');
          headers.unshift({
            text: 'Ubicación',
            align: 'left',
            sortable: true,
            value: 'idUbicacion',
          });
        }
        return headers;
      },
      today(){
        return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
      },
      computedLabel(){
        let label = `Nombre / Código de la ${this.tipoLabel}`;
        if(this.esAlgunaCategoriaEspecifica) label = `Número Económico`;
        return label;
      },
      esAlgunaCategoriaEspecifica(){
        const currentObject = this.view ? 'viewedItem' : 'editedItem';
        const categoria = this.categorias.find( (categoria) => categoria.idMaquinaCategoria == this[currentObject].idMaquinaCategoria );
        if(!categoria) return false;
        const nombreCategoria = categoria.nombre.toLowerCase().trim();
        return (nombreCategoria.includes(this.tiposCategorias[0]) || nombreCategoria.includes(this.tiposCategorias[1]) || nombreCategoria.includes(this.tiposCategorias[2]));
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva '+this.tipoLabel : 'Editar '+this.tipoLabel
      },
      tipoLabel(){
        if(this.view){
          return  this.viewedItem.esMaquina?'Máquina' : 'Herramienta';
        }
        if(this.dialog){
          return  this.editedItem.esMaquina?'Máquina' : 'Herramienta';
        }
      },
      catMaquinasFiltrado(){
        let me = this;
        return this.catMaquinas.filter(function(el) {
          return (el.esMaquina === me.editedItem.esMaquina && el.idMaquinaCategoria == me.editedItem.idMaquinaCategoria);
        });
      },
      sensorTipoLabel(){
        return (item) => {
          if(!item) return '';
          return item.nombre || item.Nombre || item.tipo || item.Tipo || `Sensor ${item.idTipoSensor || item.IdTipoSensor || ''}`;
        };
      },
      sensorVariablesDisponibles(){
        return this.sensorVariablesCatalogo.map((item) => {
          const currentAssignment = this.maquinaSensorVariableForm.idMaquinaSensorVariable
            ? this.maquinaSensorVariables.find(
                (relation) => relation.idMaquinaSensorVariable == this.maquinaSensorVariableForm.idMaquinaSensorVariable
              )
            : null;
          const isCurrentAssignment = currentAssignment?.idSensorVariable == item.idSensorVariable;
          const assignedToCurrentMachine = this.maquinaSensorVariables.some(
            (relation) => relation.idSensorVariable == item.idSensorVariable && relation.condicion !== false
          );
          const assignedToOtherMachine = this.maquinaSensorVariablesGlobal.some(relation =>
            relation.condicion !== false &&
            relation.idSensorVariable == item.idSensorVariable &&
            relation.idMaquinaIns != this.getMaquinaAsignacionId()
          );
          const duplicatedInCurrentMachine = assignedToCurrentMachine && !isCurrentAssignment;

          return {
            ...item,
            asignacionBloqueada: assignedToOtherMachine || duplicatedInCurrentMachine,
            sensorVariableLabel: assignedToOtherMachine
              ? `${item.sensorVariableLabel} (Asignada a otra maquina)`
              : duplicatedInCurrentMachine
                ? `${item.sensorVariableLabel} (Ya asignada a esta maquina)`
                : item.sensorVariableLabel
          };
        });
      },
      maquinaYaTieneToken(){
        if(this.tokenMaquinaForm.idTokenMaquina) return false;
        return this.tokensAsignados.some(token => token.condicion !== false);
      },
      tokenActivoAsignado(){
        return this.tokensAsignados.find(token => token.condicion !== false) || null;
      },
      sensorVariableDuplicadaEnToken(){
        if(!this.maquinaSensorVariableForm.idSensorVariable) return false;
        const assignedToCurrentMachine = this.maquinaSensorVariables.some(relation =>
          relation.condicion !== false &&
          relation.idSensorVariable == this.maquinaSensorVariableForm.idSensorVariable &&
          relation.idMaquinaSensorVariable != this.maquinaSensorVariableForm.idMaquinaSensorVariable
        );
        const assignedToOtherMachine = this.maquinaSensorVariablesGlobal.some(relation =>
          relation.condicion !== false &&
          relation.idSensorVariable == this.maquinaSensorVariableForm.idSensorVariable &&
          relation.idMaquinaIns != this.getMaquinaAsignacionId()
        );
        return assignedToCurrentMachine || assignedToOtherMachine;
      },
      rangoVariableTargetYaConfigurado(){
        if(!this.rangoVariableTargetId) return false;
        return this.rangosVariables.some(rango =>
          rango.condicion !== false &&
          rango.idMaquinaSensorVariable == this.rangoVariableTargetId &&
          rango.idRango != this.rangoVariableForm.idRango
        );
      },
      variablesConectadasActivas(){
        return this.maquinaSensorVariables.filter(item => item.condicion !== false);
      },
      rangoSelectedVariable(){
        if(!this.rangoVariableTargetId) return null;
        return this.maquinaSensorVariables.find(
          v => Number(v.idMaquinaSensorVariable) === Number(this.rangoVariableTargetId)
        ) || null;
      },
      rangoVariableActiva(){
        if(!this.rangoVariableTargetId) return null;
        return this.rangosVariables.find(r =>
          r.condicion !== false &&
          Number(r.idMaquinaSensorVariable) === Number(this.rangoVariableTargetId)
        ) || null;
      },
      rangoVariableExistente(){
        return this.rangoVariableActiva;
      },
      rangoEstadoVista(){
        // 'empty' | 'create' | 'view' | 'edit'
        if(this.rangoVariableForm.idRango) return 'edit';
        if(!this.rangoVariableTargetId) return 'empty';
        if(this.rangoVariableExistente) return 'view';
        return 'create';
      },
      rangoBarSaved(){
        // Igual a rangoBar pero leyendo los valores guardados (vista saved).
        const r = this.rangoVariableExistente;
        if(!r) return null;
        const nMin = this.parseRangoNumber(r.normalMin);
        const nMax = this.parseRangoNumber(r.normalMax);
        const aMin = this.parseRangoNumber(r.advertenciaMin);
        const aMax = this.parseRangoNumber(r.advertenciaMax);
        return this.buildRangoBar(nMin, nMax, aMin, aMax);
      },
      rangoBarSavedVisible(){
        const r = this.rangoVariableExistente;
        if(!r) return false;
        const nMin = this.parseRangoNumber(r.normalMin);
        const nMax = this.parseRangoNumber(r.normalMax);
        return nMin !== null && nMax !== null && nMin <= nMax;
      },
      rangoUnidad(){
        const v = this.rangoSelectedVariable;
        return (v && (v.unidadVariable || v.unidad || v.abreviaturaUnidad)) || '';
      },
      rangoBarVisible(){
        const nMin = this.parseRangoNumber(this.rangoVariableForm.normalMin);
        const nMax = this.parseRangoNumber(this.rangoVariableForm.normalMax);
        return nMin !== null && nMax !== null && nMin <= nMax;
      },
      rangoBar(){
        const nMin = this.parseRangoNumber(this.rangoVariableForm.normalMin);
        const nMax = this.parseRangoNumber(this.rangoVariableForm.normalMax);
        const aMin = this.parseRangoNumber(this.rangoVariableForm.advertenciaMin);
        const aMax = this.parseRangoNumber(this.rangoVariableForm.advertenciaMax);
        return this.buildRangoBar(nMin, nMax, aMin, aMax);
      },
      rangoVariableEstadoDialogActivar(){
        return this.rangoVariableEstadoDialogItem?.condicion === false;
      },
      rangoVariableEstadoDialogItemId(){
        return this.rangoVariableEstadoDialogItem?.idRango || null;
      },
      rangoVariableEstadoReemplazaActiva(){
        return this.rangoVariableEstadoDialogActivar &&
          this.rangoVariableActiva &&
          this.rangoVariableActiva.idRango != this.rangoVariableEstadoDialogItemId;
      },
      rangoVariableEstadoDialogTitle(){
        return this.rangoVariableEstadoDialogActivar
          ? 'Activar configuración de rangos'
          : 'Desactivar configuración de rangos';
      },
      rangoVariableEstadoDialogCopy(){
        if(this.rangoVariableEstadoReemplazaActiva){
          return 'Esta variable ya tiene una configuración activa. Para activar esta configuración, se desactivará la configuración activa actual.';
        }
        return this.rangoVariableEstadoDialogActivar
          ? '¿Estás seguro de que deseas activar esta configuración de rangos? Al activarse, volverá a participar en la evaluación de alertas para esta variable.'
          : '¿Estás seguro de que deseas desactivar esta configuración de rangos? Mientras esté desactivada, no se generarán alertas para esta variable.';
      },
      rangoVariableEstadoDialogAlert(){
        if(this.rangoVariableEstadoReemplazaActiva){
          return 'Solo una configuración puede permanecer activa. La actual quedará inactiva y esta tomará su lugar.';
        }
        return this.rangoVariableEstadoDialogActivar
          ? 'La configuración volverá a evaluar advertencias y alarmas con los valores almacenados.'
          : 'La configuración permanecerá almacenada y podrás activarla nuevamente.';
      },
      rangoVariableEstadoDialogAlertType(){
        if(this.rangoVariableEstadoReemplazaActiva) return 'warning';
        return this.rangoVariableEstadoDialogActivar ? 'success' : 'info';
      },
      rangoVariableEstadoDialogButtonText(){
        if(this.rangoVariableEstadoReemplazaActiva) return 'Activar y desactivar actual';
        return this.rangoVariableEstadoDialogActivar ? 'Activar' : 'Desactivar';
      },
      rangoVariableEstadoDialogVariableLabel(){
        const variable = this.rangoSelectedVariable;
        if(!variable) return 'N/A';
        const sensor = variable.sensorNombre || 'Sensor';
        const codigo = variable.variableCodigo || 'N/A';
        const nombre = variable.variableNombre ? ` - ${variable.variableNombre}` : '';
        return `${sensor} | ${codigo}${nombre}`;
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    beforeMount(){
      if(this.esIndasa){
        this.headers = this.headers.filter( header => header.value != 'maquinaTipo' );
      }
      this.editedItem = structuredClone(this.defaultItem);
      this.viewedItem = structuredClone(this.defaultItem);
    },
    created () {
      this.initialize();
    },
    methods: {
      validateInteger() {
      // Si el valor es decimal o menor a 0, lo corrige automáticamente
      this.tokenCount = Math.max(0, Math.floor(this.tokenCount || 0));
    },
      AddDropTokens(item){
        console.log(item)
        this.dialogTokensExtras = true
      },
      resetTokenForm(){
        this.tokenMaquinaForm = {
          idTokenMaquina: null,
          idToken: null
        };
        this.erroresTokenForm = {
          idToken: null
        };
      },
      resetMaquinaSensorVariableForm(){
        this.maquinaSensorVariableForm = {
          idMaquinaSensorVariable: null,
          idSensorVariable: null
        };
        this.erroresMaquinaSensorVariableForm = {
          idSensorVariable: null
        };
      },
      resetRangoVariableForm(){
        this.rangoVariableForm = {
          idRango: null,
          normalMin: '',
          normalMax: '',
          advertenciaMin: '',
          advertenciaMax: '',
          fechaInicio: '',
          fechaFin: ''
        };
        this.erroresRangoVariableForm = {
          normalMin: null,
          normalMax: null,
          advertenciaMin: null,
          advertenciaMax: null,
          _general: null
        };
      },
      formatSensorVariableLabel(item = {}){
        const sensorSegment = item.sensorNombre || '';
        const variableSegment = [item.variableCodigo, item.variableNombre].filter(Boolean).join(' - ');
        return [sensorSegment, variableSegment].filter(Boolean).join(' | ') || 'Relacion';
      },
      requestSensorVariablesCatalogo(method = 'get', suffix = '', data = null, params = null){
        return axios({
          method,
          url: `/SensorVariables${suffix}`,
          data,
          params
        });
      },
      requestMaquinaSensorVariables(method, suffix = '', data = null, params = null){
        return axios({
          method,
          url: `/MaquinaSensorVariables${suffix}`,
          data,
          params
        });
      },
      requestRangosVariables(method, suffix = '', data = null, params = null){
        return axios({
          method,
          url: `/RangosVariables${suffix}`,
          data,
          params
        });
      },
      normalizeTokenCatalogo(item = {}){
        return {
          ...item,
          idToken: item.idToken || item.IdToken || item.id || item.Id || null,
          token: item.token || item.Token || '',
          tipoToken: item.tipoToken || item.TipoToken || '',
          descripcion: item.descripcion || item.Descripcion || '',
          condicion: typeof item.condicion === 'boolean' ? item.condicion : item.Condicion
        };
      },
      normalizeTokenAsignado(item = {}){
        return {
          ...item,
          idTokenMaquina: item.idTokenMaquina || item.IdTokenMaquina || item.id || item.Id || null,
          idMaquinaIns: item.idMaquinaIns || item.IdMaquinaIns || null,
          idToken: item.idToken || item.IdToken || null,
          maquina: item.maquina || item.Maquina || '',
          token: item.token || item.Token || '',
          tipoToken: item.tipoToken || item.TipoToken || '',
          descripcionToken: item.descripcionToken || item.DescripcionToken || '',
          condicion: typeof item.condicion === 'boolean' ? item.condicion : item.Condicion,
          fechaInicio: item.fechaInicio || item.FechaInicio || null,
          fechaFin: item.fechaFin || item.FechaFin || null,
          fechaCreacion: item.fechaCreacion || item.FechaCreacion || null
        };
      },
      normalizeSensorVariableCatalogo(item = {}){
        const normalized = {
          ...item,
          idSensorVariable: item.idSensorVariable || item.IdSensorVariable || item.id || item.Id || null,
          idSensor: item.idSensor || item.IdSensor || null,
          sensorCodigo: item.sensorCodigo || item.SensorCodigo || '',
          sensorNombre: item.sensorNombre || item.SensorNombre || '',
          idVariable: item.idVariable || item.IdVariable || null,
          variableCodigo: item.variableCodigo || item.VariableCodigo || '',
          variableNombre: item.variableNombre || item.VariableNombre || '',
          condicion: typeof item.condicion === 'boolean' ? item.condicion : item.Condicion
        };
        return {
          ...normalized,
          sensorVariableLabel: this.formatSensorVariableLabel(normalized)
        };
      },
      normalizeMaquinaSensorVariable(item = {}){
        const normalized = {
          ...item,
          idMaquinaSensorVariable: item.idMaquinaSensorVariable || item.IdMaquinaSensorVariable || item.id || item.Id || null,
          idMaquinaIns: item.idMaquinaIns || item.IdMaquinaIns || item.idMaquina || item.IdMaquina || null,
          maquina: item.maquina || item.Maquina || '',
          idSensorVariable: item.idSensorVariable || item.IdSensorVariable || null,
          idSensor: item.idSensor || item.IdSensor || null,
          sensorCodigo: item.sensorCodigo || item.SensorCodigo || '',
          sensorNombre: item.sensorNombre || item.SensorNombre || '',
          idVariable: item.idVariable || item.IdVariable || null,
          variableCodigo: item.variableCodigo || item.VariableCodigo || '',
          variableNombre: item.variableNombre || item.VariableNombre || '',
          condicion: typeof item.condicion === 'boolean' ? item.condicion : item.Condicion,
          rangosConfigurados: item.rangosConfigurados ?? item.RangosConfigurados ?? 0,
          fechaInicio: item.fechaInicio || item.FechaInicio || null,
          fechaFin: item.fechaFin || item.FechaFin || null
        };
        return {
          ...normalized,
          sensorLabel: normalized.sensorNombre || 'N/A',
          variableLabel: [normalized.variableCodigo, normalized.variableNombre].filter(Boolean).join(' - ') || 'N/A',
          rangoVariableTargetLabel: [
            normalized.sensorNombre,
            [normalized.variableCodigo, normalized.variableNombre].filter(Boolean).join(' - ')
          ].filter(Boolean).join(' | ') || 'Relacion'
        };
      },
      normalizeRangoVariable(item = {}) {
        return {
          ...item,
          idRango: item.idRango || item.IdRango || item.id || item.Id || null,
          idMaquinaSensorVariable: item.idMaquinaSensorVariable || item.IdMaquinaSensorVariable || null,
          normalMin: item.normalMin ?? item.NormalMin ?? '',
          normalMax: item.normalMax ?? item.NormalMax ?? '',
          advertenciaMin: item.advertenciaMin ?? item.AdvertenciaMin ?? '',
          advertenciaMax: item.advertenciaMax ?? item.AdvertenciaMax ?? '',
          fechaInicio: item.fechaInicio || item.FechaInicio || null,
          fechaFin: item.fechaFin || item.FechaFin || null,
          condicion: typeof item.condicion === 'boolean' ? item.condicion : item.Condicion
        };
      },
      getTokensCatalogo(){
        this.loadingTokensCatalogo = true;
        return axios
          .get('/CatTokens')
          .then((response) => {
            const items = Array.isArray(response.data) ? response.data : [];
            this.tokensCatalogo = items
              .map(this.normalizeTokenCatalogo)
              .filter(item => item.condicion !== false);
          })
          .catch((error) => {
            console.log(error);
            this.tokensCatalogo = [];
          })
          .finally(() => {
            this.loadingTokensCatalogo = false;
          });
      },
      loadTokensAsignados(idMaquinaIns){
        if(!idMaquinaIns){
          this.tokensAsignados = [];
          this.tokensHistorialMaquina = [];
          return Promise.resolve();
        }

        this.loadingTokensAsignados = true;
        return axios
          .get('/MaquinaTokens?incluirInactivos=true')
          .then((response) => {
            const items = (Array.isArray(response.data) ? response.data : [])
              .map(this.normalizeTokenAsignado)
              .filter(item => item.idMaquinaIns == idMaquinaIns);
            // Historial completo (activas e inactivas) para esta maquina.
            this.tokensHistorialMaquina = items;
            // Activas para la logica existente de disponibilidad y validaciones.
            this.tokensAsignados = items.filter(item => item.condicion !== false);
          })
          .catch((error) => {
            console.log(error);
            this.tokensAsignados = [];
            this.tokensHistorialMaquina = [];
          })
          .finally(() => {
            this.loadingTokensAsignados = false;
          });
      },
      getSensorVariablesCatalogo(){
        this.loadingSensorVariablesCatalogo = true;
        return this.requestSensorVariablesCatalogo('get')
          .then((response) => {
            const items = Array.isArray(response.data) ? response.data : [];
            this.sensorVariablesCatalogo = items
              .map(this.normalizeSensorVariableCatalogo)
              .filter(item => item.condicion !== false);
          })
          .catch((error) => {
            console.log(error);
            this.sensorVariablesCatalogo = [];
          })
          .finally(() => {
            this.loadingSensorVariablesCatalogo = false;
          });
      },
      getMaquinaAsignacionId(){
        return this.maquinaAsignacion?.idMaquinaIns || this.maquinaAsignacion?.IdMaquinaIns || null;
      },
      loadMaquinaSensorVariables(idMaquina){
        if(!idMaquina){
          this.maquinaSensorVariables = [];
          this.maquinaSensorVariablesGlobal = [];
          this.rangoVariableTargetId = null;
          this.rangosVariables = [];
          this.resetRangoVariableForm();
          return Promise.resolve();
        }

        this.loadingMaquinaSensorVariables = true;
        return this.requestMaquinaSensorVariables('get', '', null, { incluirInactivos: true })
          .then((response) => {
            const items = Array.isArray(response.data) ? response.data : [];
            const normalizedItems = items.map(this.normalizeMaquinaSensorVariable);
            // Global solo activas (para validaciones de duplicados).
            this.maquinaSensorVariablesGlobal = normalizedItems.filter(item => item.condicion !== false);
            // Tabla: activas e inactivas de esta maquina (las inactivas no se ocultan).
            this.maquinaSensorVariables = normalizedItems
              .filter(item => item.idMaquinaIns == idMaquina);
            const activas = this.maquinaSensorVariables.filter(item => item.condicion !== false);
            const targetExists = activas.some(
              item => item.idMaquinaSensorVariable == this.rangoVariableTargetId
            );
            if(!targetExists){
              this.rangoVariableTargetId = activas[0]?.idMaquinaSensorVariable || null;
            }
          })
          .then(() => axios.get('/MaquinaTokens'))
          .then((response) => {
            this.syncMaquinasTokensState(response.data);
            return this.rangoVariableTargetId
              ? this.loadRangosVariables(this.rangoVariableTargetId)
              : Promise.resolve();
          })
          .catch((error) => {
            console.log(error);
            this.maquinaSensorVariables = [];
            this.maquinaSensorVariablesGlobal = [];
            this.rangoVariableTargetId = null;
            this.rangosVariables = [];
            this.resetRangoVariableForm();
          })
          .finally(() => {
            this.loadingMaquinaSensorVariables = false;
          });
      },
      onRangoVariableTargetChange(idMaquinaSensorVariable){
        this.resetRangoVariableForm();
        this.showRangosGuardados = false;
        this.loadRangosVariables(idMaquinaSensorVariable);
      },
      loadRangosVariables(idMaquinaSensorVariable){
        if(!idMaquinaSensorVariable){
          this.rangosVariables = [];
          this.resetRangoVariableForm();
          return Promise.resolve();
        }

        this.loadingRangosVariables = true;
        return this.requestRangosVariables('get', `/PorMaquinaSensorVariable/${idMaquinaSensorVariable}`)
          .then((response) => {
            const items = Array.isArray(response.data) ? response.data : [];
            this.rangosVariables = items.map(this.normalizeRangoVariable);
          })
          .catch((error) => {
            console.log(error);
            this.rangosVariables = [];
          })
          .finally(() => {
            this.loadingRangosVariables = false;
          });
      },
      validateTokenAsignacion(){
        this.erroresTokenForm.idToken = null;
        if(!this.tokenMaquinaForm.idToken){
          this.erroresTokenForm.idToken = 'Seleccione un token';
        }
        // Una maquina solo puede tener un token activo: si ya tiene uno,
        // se debe desactivar antes de asignar otro.
        if(this.tokensAsignados.some(token => token.condicion !== false)){
          this.erroresTokenForm.idToken = 'La máquina ya tiene un token activo. Desactívalo antes de asignar otro.';
        }
        const enOtraMaquina = this.getTokensAsignadosSnapshot()
          .find((item) =>
            item.condicion !== false &&
            item.idToken == this.tokenMaquinaForm.idToken &&
            item.idMaquinaIns != this.getMaquinaAsignacionId()
          );
        if(enOtraMaquina){
          this.erroresTokenForm.idToken = 'Ese token ya está asignado y activo en otra máquina.';
        }
        return !this.erroresTokenForm.idToken;
      },
      validateMaquinaSensorVariable(){
        this.erroresMaquinaSensorVariableForm = {
          idSensorVariable: null
        };

        if(!this.maquinaSensorVariableForm.idSensorVariable){
          this.erroresMaquinaSensorVariableForm.idSensorVariable = 'Seleccione una relacion sensor-variable';
        }
        const currentAssignment = this.maquinaSensorVariableForm.idMaquinaSensorVariable
          ? this.maquinaSensorVariables.find(
              relation => relation.idMaquinaSensorVariable == this.maquinaSensorVariableForm.idMaquinaSensorVariable
            )
          : null;
        const duplicatedInCurrentMachine = this.maquinaSensorVariables.some(relation =>
          relation.condicion !== false &&
          relation.idSensorVariable == this.maquinaSensorVariableForm.idSensorVariable &&
          relation.idMaquinaSensorVariable != currentAssignment?.idMaquinaSensorVariable
        );
        const assignedToOtherMachine = this.maquinaSensorVariablesGlobal.some(relation =>
          relation.condicion !== false &&
          relation.idSensorVariable == this.maquinaSensorVariableForm.idSensorVariable &&
          relation.idMaquinaIns != this.getMaquinaAsignacionId()
        );
        if(assignedToOtherMachine){
          this.erroresMaquinaSensorVariableForm.idSensorVariable = 'Esta relacion sensor-variable ya fue asignada a otra maquina.';
        } else if(duplicatedInCurrentMachine){
          this.erroresMaquinaSensorVariableForm.idSensorVariable = 'Esta relacion sensor-variable ya fue asignada a esta maquina.';
        }

        return !Object.values(this.erroresMaquinaSensorVariableForm).some(value => value != null);
      },
      getTokensDisponiblesParaAsignacion(){
        const ocupados = new Set(
          this.getTokensAsignadosSnapshot()
            .map(item => item?.idToken)
            .filter(id => id != null)
        );

        return this.tokensCatalogo.filter((token) => {
          if(token.idToken == this.tokenMaquinaForm.idToken) return true;
          return !ocupados.has(token.idToken);
        });
      },
      getTokensAsignadosSnapshot(){
        const tokensListado = this.maquinas
          .flatMap(maquina => Array.isArray(maquina.tokensAsignados) ? maquina.tokensAsignados : []);
        const tokensDialogo = Array.isArray(this.tokensAsignados) ? this.tokensAsignados : [];
        return [...tokensListado, ...tokensDialogo].map(this.normalizeTokenAsignado);
      },
      syncMaquinasTokensState(items = []){
        const normalizedItems = (Array.isArray(items) ? items : []).map(this.normalizeTokenAsignado);
        this.maquinas = this.maquinas.map((maquina) => ({
          ...maquina,
          tokensAsignados: normalizedItems.filter(token => token.idMaquinaIns == maquina.idMaquinaIns && token.condicion !== false)
        }));
        this.tokensCatalogo = this.getTokensDisponiblesParaAsignacion();
      },
      editTokenAsignacion(item){
        const idTokenMaquina = item.idTokenMaquina || null;
        if(!idTokenMaquina) return;

        axios
          .get(`/MaquinaTokens/Mostrar/${idTokenMaquina}`)
          .then((response) => {
            const detail = this.normalizeTokenAsignado(response?.data || item);
            this.tokenMaquinaForm = {
              idTokenMaquina: detail.idTokenMaquina || null,
              idToken: detail.idToken || null
            };
            this.erroresTokenForm.idToken = null;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      asignarToken(){
        if(!this.maquinaAsignacion?.idMaquinaIns || !this.validateTokenAsignacion()) return;

        // M-0010: si ya existe una asignacion previa inactiva con este token,
        // se confirma la reactivacion en lugar de crear un registro nuevo.
        const inactivaPrevia = this.tokensHistorialMaquina.find(
          token => token.idToken == this.tokenMaquinaForm.idToken && token.condicion === false
        );
        if(inactivaPrevia){
          this.reactivarTokenInfo = inactivaPrevia;
          this.dialogReactivarToken = true;
          return;
        }

        this.ejecutarAsignacionToken();
      },
      confirmarReactivarToken(){
        this.dialogReactivarToken = false;
        this.ejecutarAsignacionToken();
      },
      cancelarReactivarToken(){
        this.dialogReactivarToken = false;
        this.reactivarTokenInfo = null;
      },
      ejecutarAsignacionToken(){
        if(!this.maquinaAsignacion?.idMaquinaIns) return;

        this.savingTokenAsignacion = true;
        const payload = {
          idMaquinaIns: this.maquinaAsignacion.idMaquinaIns,
          idToken: this.tokenMaquinaForm.idToken
        };

        axios.post('/MaquinaTokens/Crear', payload)
          .then(() => {
            this.reactivarTokenInfo = null;
            this.resetTokenForm();
            return Promise.all([
              this.getTokensCatalogo(),
              this.loadTokensAsignados(this.maquinaAsignacion.idMaquinaIns)
            ]);
          })
          .then(() => axios.get('/MaquinaTokens'))
          .then((response) => {
            this.syncMaquinasTokensState(response.data);
          })
          .catch((error) => {
            const message = error?.response?.data?.msg || error?.response?.data || 'No se pudo guardar la asignación.';
            this.erroresTokenForm.idToken = typeof message === 'string'
              ? message
              : 'No se pudo guardar la asignación.';
            console.log(error);
          })
          .finally(() => {
            this.savingTokenAsignacion = false;
          });
      },
      deleteTokenAsignacion(item){
        const idTokenMaquina = item?.idTokenMaquina;
        if(!idTokenMaquina) return;

        this.deletingTokenAsignacionId = idTokenMaquina;
        axios
          .put(`/MaquinaTokens/Desactivar/${idTokenMaquina}`)
          .then(() => Promise.all([
            this.getTokensCatalogo(),
            this.loadTokensAsignados(this.maquinaAsignacion?.idMaquinaIns)
          ]))
          .then(() => axios.get('/MaquinaTokens'))
          .then((response) => {
            this.syncMaquinasTokensState(response.data);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.deletingTokenAsignacionId = null;
          });
      },
      resetSensorForm(){
        this.sensorForm = {
          idSensor: null,
          idTipoSensor: null,
          tokenDispositivo: '',
          descripcion: ''
        };
        this.erroresSensorForm = {
          idTipoSensor: null,
          tokenDispositivo: null,
          descripcion: null
        };
      },
      resetSensorRangoForm(){
        this.sensorRangoForm = {
          idRango: null,
          cantidadMuestras: '',
          desviacionInferior: '',
          desviacionSuperior: ''
        };
        this.erroresSensorRangoForm = {
          cantidadMuestras: null,
          desviacionInferior: null,
          desviacionSuperior: null
        };
      },
      normalizeTipoSensor(item = {}){
        return {
          ...item,
          idTipoSensor: item.idTipoSensor || item.IdTipoSensor || item.id || item.Id || null,
          nombre: item.nombre || item.Nombre || item.tipo || item.Tipo || ''
        };
      },
      normalizeSensorAsignado(item = {}){
        const idTipoSensor =
          item.idTipoSensor ||
          item.IdTipoSensor ||
          (item.tipoSensor && (item.tipoSensor.idTipoSensor || item.tipoSensor.IdTipoSensor)) ||
          null;
        const tipoSensor = this.tiposSensoresCatalogo.find(sensor => sensor.idTipoSensor == idTipoSensor);

        return {
          ...item,
          idSensor: item.idSensor || item.IdSensor || null,
          idTipoSensor,
          tokenDispositivo: item.tokenDispositivo || item.TokenDispositivo || item.token || item.Token || '',
          descripcion: item.descripcion || item.Descripcion || '',
          tipoSensorLabel:
            item.tipoSensorNombre ||
            item.TipoSensorNombre ||
            item.nombreTipoSensor ||
            item.NombreTipoSensor ||
            item.tipoSensor?.nombre ||
            item.TipoSensor?.Nombre ||
            tipoSensor?.nombre ||
            'N/A'
        };
      },
      normalizeSensorRango(item = {}){
        const cantidadMuestras = item.cantidadMuestras ?? item.CantidadMuestras ?? item.muestras ?? item.Muestras ?? '';
        const desviacionInferior = item.desviacionInferior ?? item.DesviacionInferior ?? item.minimo ?? item.Minimo ?? '';
        const desviacionSuperior = item.desviacionSuperior ?? item.DesviacionSuperior ?? item.maximo ?? item.Maximo ?? '';
        const sensorLabel =
          item.sensorLabel ||
          item.SensorLabel ||
          item.nombreSensor ||
          item.NombreSensor ||
          item.tipoSensorNombre ||
          item.TipoSensorNombre ||
          this.sensorRangoTarget?.tipoSensorLabel ||
          'N/A';

        return {
          ...item,
          idRango: item.idRango || item.IdRango || item.idSensorRango || item.IdSensorRango || item.id || item.Id || null,
          idSensor: item.idSensor || item.IdSensor || item.sensorId || item.SensorId || null,
          sensorLabel,
          cantidadMuestras: cantidadMuestras === null ? '' : `${cantidadMuestras}`,
          desviacionInferior: desviacionInferior === null ? '' : `${desviacionInferior}`,
          desviacionSuperior: desviacionSuperior === null ? '' : `${desviacionSuperior}`
        };
      },
      requestTiposSensores(method, action, data){
        const routes = ['/TiposSensores', '/TipoSensor'];
        const attempt = (index) => {
          const url = `${routes[index]}/${action}`;
          return axios({ method, url, data }).catch((error) => {
            const status = error?.response?.status || null;
            if(status === 404 && index < routes.length - 1){
              return attempt(index + 1);
            }
            throw error;
          });
        };

        return attempt(0);
      },
      requestSensoresRangos(method, action, data, params){
        const routes = ['/SensoresRangos', '/SensorRango'];
        const attempt = (index) => {
          const url = `${routes[index]}/${action}`;
          return axios({ method, url, data, params }).catch((error) => {
            const status = error?.response?.status || null;
            if(status === 404 && index < routes.length - 1){
              return attempt(index + 1);
            }
            throw error;
          });
        };

        return attempt(0);
      },
      requestMaquinaSensores(method, action, data, params){
        const routes = ['/MaquinaSensores', '/MaquinaSensor'];
        const attempt = (index) => {
          const url = `${routes[index]}/${action}`;
          return axios({ method, url, data, params }).catch((error) => {
            const status = error?.response?.status || null;
            if(status === 404 && index < routes.length - 1){
              return attempt(index + 1);
            }
            throw error;
          });
        };

        return attempt(0);
      },
      getTiposSensoresCatalogo(){
        this.loadingTiposSensores = true;
        return this.requestTiposSensores('get', 'Listar')
          .then((response) => {
            const items = Array.isArray(response.data) ? response.data : [];
            this.tiposSensoresCatalogo = items.map(this.normalizeTipoSensor);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loadingTiposSensores = false;
          });
      },
      loadSensoresAsignados(idMaquinaIns){
        if(!idMaquinaIns){
          this.sensoresAsignados = [];
          return Promise.resolve();
        }

        this.loadingSensoresAsignados = true;
        return this.requestMaquinaSensores('get', 'Listar', null, { idMaquinaIns })
          .then((response) => {
            const items = Array.isArray(response.data) ? response.data : [];
            this.sensoresAsignados = items.map(this.normalizeSensorAsignado);
          })
          .catch((error) => {
            console.log(error);
            this.sensoresAsignados = [];
          })
          .finally(() => {
            this.loadingSensoresAsignados = false;
          });
      },
      loadSensorRangos(idSensor){
        if(!idSensor){
          this.sensorRangos = [];
          this.resetSensorRangoForm();
          return Promise.resolve();
        }

        this.loadingRangosSensores = true;
        return this.requestSensoresRangos('get', 'Listar', null, { idSensor })
          .then((response) => {
            const items = Array.isArray(response.data) ? response.data : [];
            this.sensorRangos = items.map(this.normalizeSensorRango);
            if(this.sensorRangos.length === 1){
              this.editSensorRango(this.sensorRangos[0]);
            } else if(!this.sensorRangos.length){
              this.resetSensorRangoForm();
            }
          })
          .catch((error) => {
            console.log(error);
            this.sensorRangos = [];
            this.resetSensorRangoForm();
          })
          .finally(() => {
            this.loadingRangosSensores = false;
          });
      },
      openAsignacionTokens(item){
        this.maquinaAsignacion = structuredClone(item);
        this.dialogAsignacionTokens = true;
        this.resetTokenForm();
        Promise.all([
          this.getTokensCatalogo(),
          this.loadTokensAsignados(item.idMaquinaIns)
        ]).then(() => {
          return axios.get('/MaquinaTokens');
        }).then((response) => {
          const items = Array.isArray(response.data) ? response.data : [];
          this.maquinas = this.maquinas.map((maquina) => ({
            ...maquina,
            tokensAsignados: items
              .map(this.normalizeTokenAsignado)
              .filter(token => token.idMaquinaIns == maquina.idMaquinaIns && token.condicion !== false)
          }));
          this.tokensCatalogo = this.getTokensDisponiblesParaAsignacion();
        }).catch((error) => {
          console.log(error);
        });
      },
      closeAsignacionTokens(){
        this.dialogAsignacionTokens = false;
        this.maquinaAsignacion = null;
        this.tokensAsignados = [];
        this.resetTokenForm();
      },
      openConfiguracionMaquina(item){
        if(!this.sensoresTokenMaquina) return;
        const idMaquina = item?.idMaquinaIns || item?.IdMaquinaIns || item?.idMaquina || item?.IdMaquina || null;
        this.maquinaAsignacion = structuredClone(item);
        this.dialogConfiguracionMaquina = true;
        this.resetTokenForm();
        this.resetMaquinaSensorVariableForm();
        Promise.all([
          this.getTokensCatalogo(),
          this.loadTokensAsignados(idMaquina),
          this.getSensorVariablesCatalogo(),
          this.loadMaquinaSensorVariables(idMaquina)
        ]).then(() => {
          return axios.get('/MaquinaTokens');
        }).then((response) => {
          this.syncMaquinasTokensState(response.data);
        }).catch((error) => {
          console.log(error);
        });
      },
      closeConfiguracionMaquina(){
        this.dialogConfiguracionMaquina = false;
        this.maquinaAsignacion = null;
        this.tokensAsignados = [];
        this.maquinaSensorVariables = [];
        this.maquinaSensorVariablesGlobal = [];
        this.sensorVariablesCatalogo = [];
        this.rangoVariableTargetId = null;
        this.rangosVariables = [];
        this.resetTokenForm();
        this.resetMaquinaSensorVariableForm();
        this.resetRangoVariableForm();
      },
      openAsignacionSensorVariables(item){
        const idMaquina = item?.idMaquinaIns || item?.IdMaquinaIns || item?.idMaquina || item?.IdMaquina || null;
        this.maquinaAsignacion = structuredClone(item);
        this.dialogAsignacionSensorVariables = true;
        this.resetMaquinaSensorVariableForm();
        Promise.all([
          this.getSensorVariablesCatalogo(),
          this.loadMaquinaSensorVariables(idMaquina)
        ]).catch((error) => {
          console.log(error);
        });
      },
      closeAsignacionSensorVariables(){
        this.dialogAsignacionSensorVariables = false;
        this.maquinaAsignacion = null;
        this.maquinaSensorVariables = [];
        this.maquinaSensorVariablesGlobal = [];
        this.sensorVariablesCatalogo = [];
        this.rangoVariableTargetId = null;
        this.rangosVariables = [];
        this.resetMaquinaSensorVariableForm();
        this.resetRangoVariableForm();
      },
      editMaquinaSensorVariable(item){
        const idMaquinaSensorVariable = item?.idMaquinaSensorVariable;
        if(!idMaquinaSensorVariable) return;

        this.requestMaquinaSensorVariables('get', `/Mostrar/${idMaquinaSensorVariable}`)
          .then((response) => {
            const detail = this.normalizeMaquinaSensorVariable(response?.data || item);
            this.maquinaSensorVariableForm = {
              idMaquinaSensorVariable: detail.idMaquinaSensorVariable || null,
              idSensorVariable: detail.idSensorVariable || null
            };
            this.erroresMaquinaSensorVariableForm = {
              idSensorVariable: null
            };
          })
          .catch((error) => {
            console.log(error);
          });
      },
      saveMaquinaSensorVariable(){
        const idMaquina = this.getMaquinaAsignacionId();
        if(!idMaquina || !this.validateMaquinaSensorVariable()) return;

        this.savingMaquinaSensorVariable = true;
        const isEditing = !!this.maquinaSensorVariableForm.idMaquinaSensorVariable;
        const payload = {
          idMaquinaIns: idMaquina,
          idSensorVariable: this.maquinaSensorVariableForm.idSensorVariable
        };

        this.requestMaquinaSensorVariables(
          isEditing ? 'put' : 'post',
          isEditing
            ? `/Actualizar/${this.maquinaSensorVariableForm.idMaquinaSensorVariable}`
            : '/Crear',
          payload
        )
          .then(() => {
            this.resetMaquinaSensorVariableForm();
            return this.loadMaquinaSensorVariables(idMaquina);
          })
          .catch((error) => {
            const message = error?.response?.data?.msg || error?.response?.data || 'No se pudo guardar la asignacion.';
            const normalizedMessage = typeof message === 'string'
              ? message
              : 'No se pudo guardar la asignacion.';

            this.erroresMaquinaSensorVariableForm.idSensorVariable = normalizedMessage;
            console.log(error);
          })
          .finally(() => {
            this.savingMaquinaSensorVariable = false;
          });
      },
      deleteMaquinaSensorVariable(item){
        const idMaquinaSensorVariable = item?.idMaquinaSensorVariable;
        const idMaquina = this.getMaquinaAsignacionId();
        if(!idMaquinaSensorVariable || !idMaquina) return;

        this.deletingMaquinaSensorVariableId = idMaquinaSensorVariable;
        // Regla de negocio: una relacion Maquina-Sensor-Variable con rangos activos
        // no puede desactivarse directamente. Primero deben desactivarse los rangos.
        this.requestRangosVariables('get', `/PorMaquinaSensorVariable/${idMaquinaSensorVariable}`)
          .then((response) => {
            const rangos = (Array.isArray(response.data) ? response.data : [])
              .map(this.normalizeRangoVariable);
            const rangosActivos = rangos.filter(rango => rango.condicion !== false);

            if(rangosActivos.length > 0){
              this.variableConectadaBloqueadaItem = item;
              this.variableConectadaBloqueadaRangos = rangosActivos;
              this.dialogVariableConectadaBloqueada = true;
              // Recargar para que el interruptor vuelva a su estado real.
              return this.loadMaquinaSensorVariables(idMaquina);
            }

            return this.requestMaquinaSensorVariables('put', `/Desactivar/${idMaquinaSensorVariable}`)
              .then(() => this.loadMaquinaSensorVariables(idMaquina));
          })
          .catch((error) => {
            console.log(error);
            // Recargar para que el interruptor vuelva a su estado real.
            return this.loadMaquinaSensorVariables(idMaquina);
          })
          .finally(() => {
            this.deletingMaquinaSensorVariableId = null;
            // Forzar que el interruptor se re-renderice con el estado real.
            this.vcSwitchNonce += 1;
          });
      },
      activarVariableConectada(item){
        const idMaquinaSensorVariable = item?.idMaquinaSensorVariable;
        const idMaquina = this.getMaquinaAsignacionId();
        if(!idMaquinaSensorVariable || !idMaquina) return;

        this.deletingMaquinaSensorVariableId = idMaquinaSensorVariable;
        this.requestMaquinaSensorVariables('put', `/Activar/${idMaquinaSensorVariable}`)
          .then(() => this.loadMaquinaSensorVariables(idMaquina))
          .catch((error) => {
            console.log(error);
            return this.loadMaquinaSensorVariables(idMaquina);
          })
          .finally(() => {
            this.deletingMaquinaSensorVariableId = null;
            this.vcSwitchNonce += 1;
          });
      },
      toggleVariableConectada(item){
        if(item.condicion === false){
          this.activarVariableConectada(item);
        } else {
          this.deleteMaquinaSensorVariable(item);
        }
      },
      verDetallesRangos(item){
        if(!item || !item.idMaquinaSensorVariable) return;
        this.rangoVariableTargetId = item.idMaquinaSensorVariable;
        this.onRangoVariableTargetChange(item.idMaquinaSensorVariable);
      },
      formatFechaHora(value){
        if(!value) return '—';
        const d = new Date(value);
        if(Number.isNaN(d.getTime())) return `${value}`.substring(0, 10);
        return d.toLocaleString('es-MX', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      },
      closeVariableConectadaBloqueada(){
        this.dialogVariableConectadaBloqueada = false;
        this.variableConectadaBloqueadaItem = null;
        this.variableConectadaBloqueadaRangos = [];
      },
      irAConfigurarRangosBloqueados(){
        const item = this.variableConectadaBloqueadaItem;
        if(item && item.idMaquinaSensorVariable){
          this.rangoVariableTargetId = item.idMaquinaSensorVariable;
          this.onRangoVariableTargetChange(item.idMaquinaSensorVariable);
        }
        this.closeVariableConectadaBloqueada();
      },
      variableConectadaBloqueadaLabel(){
        const item = this.variableConectadaBloqueadaItem;
        if(!item) return 'seleccionada';
        return [item.sensorLabel, item.variableLabel].filter(Boolean).join(' / ') || 'seleccionada';
      },
      parseRangoNumber(value){
        if(value === null || value === '') return null;
        const parsed = parseFloat(value);
        return Number.isNaN(parsed) ? null : parsed;
      },
      formatRangoNum(value){
        if(value === null || value === undefined || value === '') return '—';
        const num = Number(value);
        if(Number.isNaN(num)) return '—';
        return num.toFixed(2);
      },
      buildRangoBar(nMin, nMax, aMin, aMax){
        const result = {
          alarmaBaja: null,
          advBaja: null,
          normal: { lower: nMin, upper: nMax },
          advAlta: null,
          alarmaAlta: null,
          segments: [],
          ticks: [],
        };
        if(nMin === null || nMax === null) return result;

        const span = (nMax - nMin) || 1;
        const lowEdge = aMin !== null ? aMin : nMin;
        const highEdge = aMax !== null ? aMax : nMax;
        const totalSpan = (highEdge - lowEdge) || 1;
        const pad = Math.max(totalSpan * 0.2, span * 0.2, 1);
        const barLow = lowEdge - pad;
        const barHigh = highEdge + pad;
        const barRange = barHigh - barLow;
        const pos = (v) => Math.max(0, Math.min(100, ((v - barLow) / barRange) * 100));

        if(aMin !== null){
          result.alarmaBaja = { lower: barLow, upper: aMin };
          result.advBaja = { lower: aMin, upper: nMin };
        }
        if(aMax !== null){
          result.advAlta = { lower: nMax, upper: aMax };
          result.alarmaAlta = { lower: aMax, upper: barHigh };
        }

        const segs = [];
        if(result.alarmaBaja) segs.push({ kind: 'alarma', flex: Math.max(0.5, (aMin - barLow)) });
        if(result.advBaja) segs.push({ kind: 'adv', flex: Math.max(0.5, (nMin - aMin)) });
        segs.push({ kind: 'normal', flex: Math.max(0.5, (nMax - nMin) || 1) });
        if(result.advAlta) segs.push({ kind: 'adv', flex: Math.max(0.5, (aMax - nMax)) });
        if(result.alarmaAlta) segs.push({ kind: 'alarma', flex: Math.max(0.5, (barHigh - aMax)) });
        result.segments = segs;

        const ticks = [];
        if(aMin !== null) ticks.push({ value: aMin, pos: pos(aMin) });
        ticks.push({ value: nMin, pos: pos(nMin) });
        ticks.push({ value: nMax, pos: pos(nMax) });
        if(aMax !== null) ticks.push({ value: aMax, pos: pos(aMax) });
        result.ticks = ticks;

        return result;
      },
      validateRangoVariable(){
        this.resetRangoVariableErrors();

        if(!this.rangoVariableTargetId){
          this.erroresRangoVariableForm._general = 'Selecciona una variable de la maquina antes de configurar los rangos.';
          return false;
        }

        if(this.rangoVariableTargetYaConfigurado){
          this.erroresRangoVariableForm._general = 'Esta relacion sensor-variable ya tiene una configuracion activa. Solo se permite una.';
          return false;
        }

        // Los 4 campos son obligatorios
        const required = [
          { field: 'advertenciaMin', label: 'el minimo de advertencia' },
          { field: 'normalMin', label: 'el minimo normal' },
          { field: 'normalMax', label: 'el maximo normal' },
          { field: 'advertenciaMax', label: 'el maximo de advertencia' },
        ];
        required.forEach((r) => {
          const raw = this.rangoVariableForm[r.field];
          if(raw === '' || raw === null || raw === undefined){
            this.erroresRangoVariableForm[r.field] = `Captura ${r.label}.`;
          } else if(Number.isNaN(parseFloat(raw))){
            this.erroresRangoVariableForm[r.field] = 'Captura un valor numerico.';
          }
        });

        if(Object.values(this.erroresRangoVariableForm).some(v => v)) return false;

        const advMin = this.parseRangoNumber(this.rangoVariableForm.advertenciaMin);
        const norMin = this.parseRangoNumber(this.rangoVariableForm.normalMin);
        const norMax = this.parseRangoNumber(this.rangoVariableForm.normalMax);
        const advMax = this.parseRangoNumber(this.rangoVariableForm.advertenciaMax);

        // normalMin <= normalMax
        if(norMin > norMax){
          this.erroresRangoVariableForm.normalMax = 'Debe ser mayor o igual al minimo normal.';
        }
        // advertenciaMin <= normalMin
        if(advMin > norMin){
          this.erroresRangoVariableForm.advertenciaMin = 'Debe ser menor o igual al minimo normal.';
        }
        // advertenciaMax >= normalMax
        if(advMax < norMax){
          this.erroresRangoVariableForm.advertenciaMax = 'Debe ser mayor o igual al maximo normal.';
        }

        return !Object.values(this.erroresRangoVariableForm).some(value => value != null);
      },
      resetRangoVariableErrors(){
        Object.keys(this.erroresRangoVariableForm).forEach((key) => {
          this.erroresRangoVariableForm[key] = null;
        });
      },
      buildRangoVariablePayload(){
        return {
          idMaquinaSensorVariable: this.rangoVariableTargetId,
          advertenciaMin: this.parseRangoNumber(this.rangoVariableForm.advertenciaMin),
          normalMin: this.parseRangoNumber(this.rangoVariableForm.normalMin),
          normalMax: this.parseRangoNumber(this.rangoVariableForm.normalMax),
          advertenciaMax: this.parseRangoNumber(this.rangoVariableForm.advertenciaMax),
          fechaInicio: this.rangoVariableForm.fechaInicio || null,
          fechaFin: this.rangoVariableForm.fechaFin || null
        };
      },
      editRangoVariable(item){
        const idRango = item?.idRango;
        if(!idRango) return;

        this.requestRangosVariables('get', `/Mostrar/${idRango}`)
          .then((response) => {
            const detail = this.normalizeRangoVariable(response?.data || item);
            this.rangoVariableForm = {
              idRango: detail.idRango || null,
              normalMin: detail.normalMin === null || detail.normalMin === '' ? '' : `${detail.normalMin}`,
              normalMax: detail.normalMax === null || detail.normalMax === '' ? '' : `${detail.normalMax}`,
              advertenciaMin: detail.advertenciaMin === null || detail.advertenciaMin === '' ? '' : `${detail.advertenciaMin}`,
              advertenciaMax: detail.advertenciaMax === null || detail.advertenciaMax === '' ? '' : `${detail.advertenciaMax}`,
              fechaInicio: detail.fechaInicio || '',
              fechaFin: detail.fechaFin || ''
            };
            this.rangoVariableTargetId = detail.idMaquinaSensorVariable || this.rangoVariableTargetId;
            this.resetRangoVariableErrors();
          })
          .catch((error) => {
            console.log(error);
          });
      },
      saveRangoVariable(){
        if(!this.validateRangoVariable()) return;

        this.savingRangoVariable = true;
        const isEditing = !!this.rangoVariableForm.idRango;
        this.requestRangosVariables(
          isEditing ? 'put' : 'post',
          isEditing
            ? `/Actualizar/${this.rangoVariableForm.idRango}`
            : '/Crear',
          this.buildRangoVariablePayload()
        )
          .then(() => {
            this.resetRangoVariableForm();
            return this.loadRangosVariables(this.rangoVariableTargetId);
          })
          .catch((error) => {
            this.applyRangoBackendError(error);
            console.log(error);
          })
          .finally(() => {
            this.savingRangoVariable = false;
          });
      },
      cleanBackendMessage(raw){
        if(!raw || typeof raw !== 'string') return '';
        // Quita prefijos tipo "[ MX EXCEPTION ] :", "[XYZ] :", etc.
        let msg = raw.replace(/^\s*\[[^\]]+\]\s*:?\s*/i, '').trim();
        // Quita comillas envolventes y puntos finales repetidos
        msg = msg.replace(/^["']|["']$/g, '').trim();
        return msg || raw;
      },
      applyRangoBackendError(error){
        const data = error?.response?.data;
        const raw = (data && (data.msg || data.message)) || (typeof data === 'string' ? data : '');
        const message = this.cleanBackendMessage(raw) || 'No se pudo guardar el rango.';

        // Detecta a que campo se refiere el mensaje (AlarmaMin, ControlMax, etc.)
        const fieldMap = [
          { keyword: 'alarmamin', field: 'alarmaMin' },
          { keyword: 'alarmamax', field: 'alarmaMax' },
          { keyword: 'toleranciamin', field: 'toleranciaMin' },
          { keyword: 'toleranciamax', field: 'toleranciaMax' },
          { keyword: 'controlmin', field: 'controlMin' },
          { keyword: 'controlmax', field: 'controlMax' },
        ];
        const lower = message.toLowerCase().replace(/\s+/g, '');
        const target = fieldMap.find(f => lower.includes(f.keyword));
        if(target){
          this.erroresRangoVariableForm[target.field] = message;
        } else {
          this.erroresRangoVariableForm._general = message;
        }
      },
      openRangoVariableEstadoDialog(item){
        if(!item?.idRango) return;
        this.rangoVariableEstadoDialogItem = item;
        this.dialogRangoVariableEstado = true;
      },
      closeRangoVariableEstadoDialog(){
        if(this.togglingRangoVariableId != null) return;
        this.dialogRangoVariableEstado = false;
        this.rangoVariableEstadoDialogItem = null;
      },
      confirmRangoVariableEstado(){
        if(!this.rangoVariableEstadoDialogItem) return;
        this.toggleRangoVariableEstado(this.rangoVariableEstadoDialogItem);
      },
      requestRangoVariableEstado(idRango, activar){
        return this.requestRangosVariables('put', activar ? `/Activar/${idRango}` : `/Desactivar/${idRango}`)
          .catch((error) => {
            const status = error?.response?.status || null;
            if(activar && status === 404){
              return this.requestRangosVariables('put', `/Reactivar/${idRango}`);
            }
            throw error;
          });
      },
      toggleRangoVariableEstado(item){
        const idRango = item?.idRango;
        if(!idRango || !this.rangoVariableTargetId) return;

        const activar = item.condicion === false;
        this.togglingRangoVariableId = idRango;
        const request = activar && this.rangoVariableActiva && this.rangoVariableActiva.idRango != idRango
          ? this.requestRangoVariableEstado(this.rangoVariableActiva.idRango, false)
            .then(() => this.requestRangoVariableEstado(idRango, true))
          : this.requestRangoVariableEstado(idRango, activar);

        request
          .then(() => {
            this.dialogRangoVariableEstado = false;
            this.rangoVariableEstadoDialogItem = null;
            return this.loadRangosVariables(this.rangoVariableTargetId);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.togglingRangoVariableId = null;
          });
      },
      formatRangoPeriodo(item){
        const inicio = item?.fechaInicio ? `${item.fechaInicio}`.substring(0, 10) : 'Sin inicio';
        const fin = item?.fechaFin ? `${item.fechaFin}`.substring(0, 10) : 'Sin fin';
        return `${inicio} - ${fin}`;
      },
      editSensorAsignacion(item){
        this.sensorForm = {
          idSensor: item.idSensor || null,
          idTipoSensor: item.idTipoSensor || null,
          tokenDispositivo: item.tokenDispositivo || '',
          descripcion: item.descripcion || ''
        };
        this.erroresSensorForm.idTipoSensor = null;
        this.erroresSensorForm.tokenDispositivo = null;
        this.erroresSensorForm.descripcion = null;
      },
      openSensorRangos(item){
        this.sensorRangoTarget = this.normalizeSensorAsignado(item);
        this.resetSensorRangoForm();
        this.loadSensorRangos(this.sensorRangoTarget.idSensor);
      },
      closeSensorRangosPanel(){
        this.sensorRangoTarget = null;
        this.sensorRangos = [];
        this.resetSensorRangoForm();
      },
      cancelSensorRangoEdit(){
        if(this.sensorRangos.length === 1){
          this.editSensorRango(this.sensorRangos[0]);
          return;
        }
        this.resetSensorRangoForm();
      },
      editSensorRango(item){
        this.sensorRangoForm = {
          idRango: item.idRango || null,
          cantidadMuestras: item.cantidadMuestras || '',
          desviacionInferior: item.desviacionInferior || '',
          desviacionSuperior: item.desviacionSuperior || ''
        };
        this.erroresSensorRangoForm.cantidadMuestras = null;
        this.erroresSensorRangoForm.desviacionInferior = null;
        this.erroresSensorRangoForm.desviacionSuperior = null;
      },
      validateSensorAsignacion(){
        this.erroresSensorForm.idTipoSensor = null;
        this.erroresSensorForm.tokenDispositivo = null;
        this.erroresSensorForm.descripcion = null;

        if(!this.sensorForm.idTipoSensor){
          this.erroresSensorForm.idTipoSensor = 'Seleccione un tipo de sensor';
        }

        if(!this.sensorForm.tokenDispositivo){
          this.erroresSensorForm.tokenDispositivo = 'Capture el token';
        } else if(this.sensorForm.tokenDispositivo.length > 255){
          this.erroresSensorForm.tokenDispositivo = 'El token debe tener una longitud menor a 255 caracteres.';
        }

        if(this.sensorForm.descripcion && this.sensorForm.descripcion.length > 255){
          this.erroresSensorForm.descripcion = 'La descripción debe tener una longitud menor a 255 caracteres.';
        }

        return !Object.values(this.erroresSensorForm).some(value => value != null);
      },
      validateSensorRango(){
        this.erroresSensorRangoForm.cantidadMuestras = null;
        this.erroresSensorRangoForm.desviacionInferior = null;
        this.erroresSensorRangoForm.desviacionSuperior = null;

        const cantidadMuestras = parseInt(this.sensorRangoForm.cantidadMuestras);
        const desviacionInferior = parseFloat(this.sensorRangoForm.desviacionInferior);
        const desviacionSuperior = parseFloat(this.sensorRangoForm.desviacionSuperior);

        if(this.sensorRangoForm.cantidadMuestras === '' || Number.isNaN(cantidadMuestras) || cantidadMuestras <= 0){
          this.erroresSensorRangoForm.cantidadMuestras = 'Capture una cantidad de muestras válida';
        }

        if(this.sensorRangoForm.desviacionInferior === '' || Number.isNaN(desviacionInferior)){
          this.erroresSensorRangoForm.desviacionInferior = 'Capture una desviación inferior válida';
        }

        if(this.sensorRangoForm.desviacionSuperior === '' || Number.isNaN(desviacionSuperior)){
          this.erroresSensorRangoForm.desviacionSuperior = 'Capture una desviación superior válida';
        }

        return !Object.values(this.erroresSensorRangoForm).some(value => value != null);
      },
      saveSensorAsignacion(){
        if(!this.maquinaAsignacion?.idMaquinaIns || !this.validateSensorAsignacion()) return;

        this.savingSensorAsignacion = true;
        const isEditing = !!this.sensorForm.idSensor;
        const payload = {
          idMaquinaIns: this.maquinaAsignacion.idMaquinaIns,
          idTipoSensor: this.sensorForm.idTipoSensor,
          tokenDispositivo: this.sensorForm.tokenDispositivo,
          descripcion: this.sensorForm.descripcion || null
        };

        this.requestMaquinaSensores(
          isEditing ? 'put' : 'post',
          isEditing ? `Actualizar/${this.sensorForm.idSensor}` : 'Crear',
          payload
        )
          .then(() => {
            const selectedSensorId = this.sensorRangoTarget?.idSensor;
            this.resetSensorForm();
            return this.loadSensoresAsignados(this.maquinaAsignacion.idMaquinaIns)
              .then(() => {
                if(selectedSensorId){
                  const updatedTarget = this.sensoresAsignados.find(sensor => sensor.idSensor == selectedSensorId);
                  if(updatedTarget){
                    this.sensorRangoTarget = this.normalizeSensorAsignado(updatedTarget);
                  }
                }
              });
          })
          .catch((error) => {
            const message = error?.response?.data?.msg || error?.response?.data || 'No se pudo guardar la asignación.';
            this.erroresSensorForm.tokenDispositivo = typeof message === 'string'
              ? message
              : 'No se pudo guardar la asignación.';
            console.log(error);
          })
          .finally(() => {
            this.savingSensorAsignacion = false;
          });
      },
      saveSensorRango(){
        if(!this.sensorRangoTarget?.idSensor || !this.validateSensorRango()) return;

        this.savingSensorRango = true;
        const isEditing = !!this.sensorRangoForm.idRango;
        if(!isEditing && this.sensorRangos.some(rango => rango.idSensor == this.sensorRangoTarget.idSensor)){
          this.erroresSensorRangoForm.cantidadMuestras = 'Solo se permite una configuración de rangos por sensor.';
          this.savingSensorRango = false;
          return;
        }
        const cantidadMuestras = parseInt(this.sensorRangoForm.cantidadMuestras);
        const desviacionInferior = parseFloat(this.sensorRangoForm.desviacionInferior);
        const desviacionSuperior = parseFloat(this.sensorRangoForm.desviacionSuperior);
        const payload = {
          idSensor: this.sensorRangoTarget.idSensor,
          cantidadMuestras,
          desviacionSuperior,
          desviacionInferior
        };

        this.requestSensoresRangos(
          isEditing ? 'put' : 'post',
          isEditing ? `Actualizar/${this.sensorRangoForm.idRango}` : 'Crear',
          payload
        )
          .then(() => {
            this.resetSensorRangoForm();
            return this.loadSensorRangos(this.sensorRangoTarget.idSensor);
          })
          .catch((error) => {
            const message = error?.response?.data?.msg || error?.response?.data || 'No se pudo guardar el rango.';
            this.erroresSensorRangoForm.cantidadMuestras = typeof message === 'string'
              ? message
              : 'No se pudo guardar el rango.';
            console.log(error);
          })
          .finally(() => {
            this.savingSensorRango = false;
          });
      },
      deleteSensorAsignacion(item){
        const idSensor = item?.idSensor;
        if(!idSensor) return;

        this.deletingSensorAsignacionId = idSensor;
        this.requestMaquinaSensores('delete', `Eliminar/${idSensor}`)
          .then(() => {
            if(this.sensorRangoTarget?.idSensor == idSensor){
              this.closeSensorRangosPanel();
            }
            return this.loadSensoresAsignados(this.maquinaAsignacion?.idMaquinaIns);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.deletingSensorAsignacionId = null;
          });
      },
      deleteSensorRango(item){
        const idRango = item?.idRango;
        if(!idRango) return;

        this.deletingSensorRangoId = idRango;
        this.requestSensoresRangos('delete', `Eliminar/${idRango}`)
          .then(() => this.loadSensorRangos(this.sensorRangoTarget?.idSensor))
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.deletingSensorRangoId = null;
          });
      },
      NuevoitemToken(){
        this.indexToken--;
        this.editedItem.tokensExtras.push({
          idTokenExtra: this.indexToken,
          valor:null,
          token: null,
          activo: false,
          multiplicador: false
        });
      },
      eliminarTokenExtra(idTokenExtra){
        this.editedItem.tokensExtras = this.editedItem.tokensExtras.filter(
          te => te.idTokenExtra !== idTokenExtra);
      },
      getNombreUbicacion(idUbicacion){
        const ubicacion = this.ubicaciones.find( ubicacion => ubicacion.idUbicacion == idUbicacion );
        return ubicacion?.nombre || "N/A";
      },
      onChangeTipoTransporte(){
        this.editedItem.fechaVencimientoVerificacion = null;
        this.editedItem.tarjetaMercantilVencimiento = null;
      },
      esCategoriaEspecifica(nombreCategoria){
        const currentObject = this.view ? 'viewedItem' : 'editedItem';
        const categoria = this.categorias.find( (categoria) => categoria.idMaquinaCategoria == this[currentObject].idMaquinaCategoria );
        return categoria?.nombre.includes(nombreCategoria.trim().toUpperCase()) || false;
      },
      resetValuesCategoria(){
        this.editedItem.numEconomico = null;
        this.editedItem.alcanceMaxMedicion = null;
        this.erroresItem.errorAlcanceMaxMed = null;
        this.editedItem.motor = null;
        this.erroresItem.errorMotor = null;
        this.editedItem.capacidad = null;
        this.erroresItem.errorCapacidad = null;
        this.editedItem.numCilindros = null;
        this.erroresItem.errorNumCilindros = null;
        this.editedItem.mastilEtapas = null;
        this.erroresItem.errorMastilEtapas = null;
        this.editedItem.propuestaNuevaNomenclatura = null;
        this.editedItem.idUsuario = null;
        this.erroresItem.errorUsuario = null;
        this.editedItem.tipoBascula = null;
        this.erroresItem.errorTipoBascula = null;
        this.editedItem.tipoTransporte = null;
        this.erroresItem.errorTipoTransporte = null;
        this.editedItem.version = null;
        this.erroresItem.errorVersion = null;
        this.editedItem.placas = null;
        this.erroresItem.errorPlacas = null;
        this.editedItem.numDeMotor = null;
        this.erroresItem.errorNumMotor = null;
        this.onChangeTipoTransporte();
      },
      onChangeCategoria(){
        this.resetIdMaquina();
        if(this.esAlgunaCategoriaEspecifica){
          this.editedItem.idArea = 1;
          this.resetValuesCategoria();
        }
        else {
          this.editedItem.idArea = -1;
        }
      },
      marcaModelo: item => item.marca +' - '+item.modelo,
      resetIdMaquina(){
        this.editedItem.idMaquina = -1;
      },
      getNombreCompleto(idPersona){
        var o = this.personas.find(x => x.idPersona == idPersona);
        if(o != null) return o.nombre+" "+o.paterno+" "+o.materno;
        else return "";
      },
      agregarImagenDB(){
        let me = this;
        let mime = me.imagenVistaPrevia.substring(5,me.imagenVistaPrevia.indexOf(";"));
        let data = me.imagenVistaPrevia.substring(me.imagenVistaPrevia.indexOf("base64,")+7);
        me.erroresImagen = [];
        
        if(data == null || data == '' || mime == null || mime == ''){
          me.erroresImagen.push('Falta Seleccionar una Imagen');
        }

        if(me.uploadImg.descripcion.length<5){
          me.erroresImagen.push('La Descripción debe de tener al menos de 5 caracteres');
        }

        if(me.erroresImagen.length>0){
          return;
        }
        axios
          .post("/MaquinaInstancias/AgregarImagen", {
            IdMaquinaIns: me.viewedItem.idMaquinaIns,
            Mime:mime,
            Imagen: data,
            Descripcion:me.uploadImg.descripcion
          })
          .then(response =>  {
            me.dialogAddImg = false;
            me.imagenVistaPrevia = '';
            me.imagenArchivo=null;
            me.uploadImg = me.defaultUploadImg;
            me.getThumbnails(me.viewedItem.idMaquinaIns);
          })
          .catch(error => {
            console.log(error);
        });
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      },
      vistaPrevia(){
        let me = this;
        if(me.imagenArchivo != null){
          this.getBase64(me.imagenArchivo).then(
            data => {
              me.imagenVistaPrevia = data;
            }
          );
        }
        else{
          me.imagenVistaPrevia = '';
        }
      },
      agregarImagen(){
        this.dialogAddImg = true;
      },
      getCatMaquinas (){
        let me = this;
        me.loadingCatMaquinas = true;
        axios
        .get("/Maquinas/Basico")
        .then(response =>  {
          me.catMaquinas = response.data;
          me.loadingCatMaquinas = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getAreas (){
        let me = this;
        me.loadingArea = true;
        axios
        .get("/Areas")
        .then(response =>  {
          me.areas = response.data;
          me.loadingArea = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getClasificaciones(){
        this.loadingClasificacion = true;
        axios
        .get("/MaquinaTipos")
        .then(response =>  {
          this.clasificaciones = response.data;
          this.loadingClasificacion = false;
        })
        .catch(error => {
          this.loadingClasificacion = false;
          console.log(error);
        });
      },
      getCategorias(){
        this.loadingCategoria = true;
        axios
        .get("/MaquinaCategorias")
        .then(response =>  {
          response.data.push({
            idMaquinaCategoria: null,
            nombre: "SIN ASIGNAR",
            descripcion:"",
            condicion: true,
          });
          this.categorias = response.data;
          this.loadingCategoria = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getOperadores (){
        let me = this;
        me.loadingOperador = true;
        axios
        .get("/Personas/OperadoresBasico")
        .then(response =>  {
          me.personas = response.data;
          me.loadingOperador = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getHabilidades (){
        let me = this;
        me.loadingHabilidades = true;
        axios
        .get("/Habilidades")
        .then(response =>  {
          me.habilidades = response.data;
          me.loadingHabilidades = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      imagenCompleta(item){
        let me = this;
        me.dialogImg = true;
        axios
        .get("/MaquinaInstancias/ImagenCompleta/"+me.viewedItem.idMaquinaIns+"/imagen/"+item.idImagen)
        .then(response =>  {
          me.imagen = response.data;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getMotoresMontacargas(){
        this.loadingMotoresMontacargas = true;
        axios
          .get('/MaquinaInstancias/GetMotoresMontacargas')
          .then( (response) => {
            this.motoresMontacargas = response.data;
          })
          .catch(console.log)
          .finally( () => {
            this.loadingMotoresMontacargas = false;
          });
      },
      initialize () {
        this.loading = true;
        this.getAreas();
        this.getHabilidades();
        this.getOperadores();
        this.getCatMaquinas();
        this.getCategorias();
        this.getClasificaciones();
        this.getUbicaciones();
        this.getUsuarios();
        this.getMotoresMontacargas();

        axios
        .get("/MaquinaInstancias")
        .then(response =>  {
          this.maquinas = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getKilometrajeActual(idMaquinaInstancia){
        this.loadingKilometrajeActual = true;

        axios
          .get('/Mantenimientos/GetUltimoKilometrajeReportado',{
            params: { idMaquinaInstancia }
          })
          .then((response) => {
            this.viewedItem.kilometrajeActual = this.$utils.strings.formatearCifra(response.data);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loadingKilometrajeActual = false;
          });
      },
      getUsuarios(){
        this.loadingUsuarios = true;

        axios
          .get('/Usuarios')
          .then( (response) => {
            this.usuarios = response.data;
          })
          .catch(console.log)
          .finally( () => {
            this.loadingUsuarios = false;
          })
      },
      getUbicaciones(){
        axios
          .get('/Ubicaciones')
          .then( (response) => {
            this.ubicaciones = response.data;
          })
          .catch(console.log);
      },
      getThumbnails(idMaquina){
        let me = this;
        axios
        .get("/MaquinaInstancias/GetThumbnails/"+idMaquina)
        .then(response =>  {
          me.viewedItem.imagenes = response.data;
        })
        .catch(error => {
          console.log(error);
        });
      },
      viewItem (item) {
        this.viewedIndex = this.maquinas.indexOf(item)
        this.viewedItem = structuredClone(item);
        this.getThumbnails(this.viewedItem.idMaquinaIns);
        this.getKilometrajeActual(item.idMaquinaIns);
        this.view = true
      },
      editItem (item) {
        this.action = 1;
        this.editedIndex = this.maquinas.indexOf(item)
        this.editedItem = structuredClone(item);
        this.dialog = true
      },

      deleteItem (item) {
        this.eliminar = true;
        this.delItem = structuredClone(item);
      },
      deleteImgDB(){
        let me = this;
        axios
        .delete("/MaquinaInstancias/EliminarImagen/"+me.viewedItem.idMaquinaIns+"/imagen/"+me.imagen.idImagen)
        .then(response =>  {
          me.imagen=me.defaultImagen;
          me.getThumbnails(me.viewedItem.idMaquinaIns);
        })
        .catch(error => {
          console.log(error);
        });
      },
      deleteItemDB(){
        let me = this;
        let item = this.delItem;
        this.loading = true;
        this.delItem = '';
        axios
          .put("/MaquinaInstancias/Desactivar/" + item.idMaquinaIns)
          .then(response =>  {
            me.initialize();
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      },
      resetErrors(){
        Object.keys(this.erroresItem).forEach( (key) => this.erroresItem[key] = null);
        this.errores = [];
      },
      close () {
        this.resetErrors();
        this.action = 0,
        this.dialog = false
        this.view = false
        this.closeAsignacionTokens();
        this.closeAsignacionSensorVariables();
        this.closeConfiguracionMaquina();
        this.indexToken = 0;
        setTimeout(() => {
          this.editedItem = structuredClone(this.defaultItem);
          this.viewedItem = structuredClone(this.defaultItem);
          this.editedIndex = -1
          this.viewedIndex = -1
        }, 200)
      },
      makeValidation(string, min, max, msgError){
        if (string?.length < min || string?.length > max)
        {
            return msgError;
        }
        else return null;
      },
      validate(){
        this.resetErrors();

        if(this.editedItem.esMaquina == null){
          this.erroresItem.errorEsMaquina = "Debe indicar el Tipo";
        }

        if(this.editedItem.idMaquinaCategoria == null){
          this.erroresItem.erroridMaquinaCategoria = "Debe indicar la Categoría";
        }

        if(this.editedItem.idArea == -1 || this.editedItem.idArea == null){
          this.erroresItem.erroridArea = 'Debe de seleccionar una Área';
        }
        if(this.editedItem.idMaquina == -1 || this.editedItem.idMaquina == null){
          this.erroresItem.erroridMaquina = 'Debe de seleccionar una '+this.tipoLabel;
        }

        var val = null;
        val = this.makeValidation(this.editedItem.nombre,1,50,"Debe tener más de 1 caracter y menos de 50.");
        if(val != null) this.erroresItem.errornombre = val;

        if(this.editedItem.fechaFabricacion == null ){
          this.erroresItem.errorfechaFabricacion = "Debe indicar la Fecha de Fabricación";
        }

        // if(this.editedItem.fechaCompra == null ){
        //   this.erroresItem.errorfechaCompra = "Debe indicar la Fecha de Compra";
        // }

        if(!this.sensoresTokenMaquina && this.editedItem.token?.length > 255){
          this.erroresItem.errortoken = 'El Token debe tener una longitud menor a 255 caracteres.';
        }

        if(!this.sensoresTokenMaquina && this.editedItem.token2?.length > 255){
          this.erroresItem.errortoken2 = 'El Token2 debe tener una longitud menor a 255 caracteres.';
        }

        if(this.esAlgunaCategoriaEspecifica){
          if(this.editedItem.idUbicacion == null) this.erroresItem.errorUbicacion = "Requerido";
        }

        if(this.esCategoriaEspecifica(this.tiposCategorias[0])){
          if(this.editedItem.tipoBascula == null) this.erroresItem.errorTipoBascula = "Requerido";
          
          const parsedAlcanceMaxMedicion = parseFloat(this.editedItem.alcanceMaxMedicion);
          if(isNaN(parsedAlcanceMaxMedicion)){
            this.erroresItem.errorAlcanceMaxMed = "Invalido"
          }
          else if(parsedAlcanceMaxMedicion < 0){
            this.erroresItem.errorAlcanceMaxMed = "Debe ser mayor o igual a 0"
          }
        }

        if(this.esCategoriaEspecifica(this.tiposCategorias[1])){
          const parsedCapacidad = parseFloat(this.editedItem.capacidad);
          if(isNaN(parsedCapacidad)){
            this.erroresItem.errorCapacidad = "Requerido"
          }
          else if(parsedCapacidad <= 0){
            this.erroresItem.errorCapacidad = "Debe ser mayor a 0"
          }

          const parsedNumCilindros = parseInt(this.editedItem.numCilindros);
          if(isNaN(parsedNumCilindros)){
            this.erroresItem.errorNumCilindros = "Requerido"
          }
          else if(parsedNumCilindros <= 0){
            this.erroresItem.errorNumCilindros = "Debe ser mayor a 0"
          }

          const parsedMastilEtapas = parseInt(this.editedItem.mastilEtapas);
          if(isNaN(parsedMastilEtapas)){
            this.erroresItem.errorMastilEtapas = "Requerido"
          }
          else if(parsedMastilEtapas < 0){
            this.erroresItem.errorMastilEtapas = "Debe ser mayor o igual a 0"
          }

          // if(this.editedItem.idUsuario == null){
          //   this.erroresItem.errorUsuario = "Requerido";
          // }
        }

        if(this.esCategoriaEspecifica(this.tiposCategorias[2])){
          if(this.editedItem.tipoTransporte == null) this.erroresItem.errorTipoTransporte = "Requerido";

          if(!this.editedItem.version) this.erroresItem.errorVersion = "Requerido";

          if(!this.editedItem.placas) this.erroresItem.errorPlacas = "Requerido";
          else if(this.editedItem.placas.length > 20) this.erroresItem.errorPlacas = "Máximo 20 caracteres";

          if(!this.editedItem.numDeMotor) this.erroresItem.errorNumMotor = "Requerido";
        }

        const hayErrores = Object.values(this.erroresItem).some( (value) => value != null );
        if(hayErrores) this.errores.push("Hay uno o mas errores, porfavor reviselos y vuelva a intentarlo")

        return !hayErrores;
      },
      save () {
        console.log(this.editedItem)
        this.action = 0;
        if(!this.validate()) return;
        this.saving = true;

        axios({
          url: this.editedIndex > -1
            ? `/MaquinaInstancias/Actualizar/${this.maquinas[this.editedIndex].idMaquinaIns}`
            : '/MaquinaInstancias/Crear',
          method: this.editedIndex > -1
            ? 'PUT'
            : 'POST',
          data: {
            IdArea: this.editedItem.idArea,
            IdMaquina:this.editedItem.idMaquina,
            idMaquinaTipo: this.editedItem.idMaquinaTipo,
            idUbicacion: this.editedItem.idUbicacion,
            idUsuario: this.editedItem.idUsuario,
            numSerie: this.editedItem.numSerie,
            Nombre: this.editedItem.nombre,
            FechaFabricacion: this.editedItem.fechaFabricacion,
            FechaCompra: this.editedItem.fechaCompra,
            token: this.sensoresTokenMaquina ? null : this.editedItem.token,
            token2: this.sensoresTokenMaquina ? null : this.editedItem.token2,
            alcanceMaxMedicion: this.editedItem.alcanceMaxMedicion ? parseFloat(this.editedItem.alcanceMaxMedicion) : null,
            capacidad: this.editedItem.capacidad ? parseFloat(this.editedItem.capacidad) : null,
            motor: this.editedItem.motor || null,
            numCilindros: this.editedItem.numCilindros ? parseInt(this.editedItem.numCilindros) : null,
            mastilEtapas: this.editedItem.mastilEtapas ? parseInt(this.editedItem.mastilEtapas) : null,
            propuestaNuevaNomenclatura: this.editedItem.propuestaNuevaNomenclatura || null,
            tipoBascula: parseInt(this.editedItem.tipoBascula) || null,
            tipoTransporte: parseInt(this.editedItem.tipoTransporte) || null,
            version: this.editedItem.version,
            placas: this.editedItem.placas,
            numDeMotor: this.editedItem.numDeMotor,
            fechaVencimientoVerificacion: this.editedItem.fechaVencimientoVerificacion,
            tarjetaMercantilVencimiento: this.editedItem.tarjetaMercantilVencimiento,
            TokensExtras : this.sensoresTokenMaquina
              ? []
              : this.editedItem.tokensExtras == null
                ? []
                : this.editedItem.tokensExtras.filter(te => ![te.valor, te.token].some(val => val == null || val === '')),
            importancia: this.editedItem.importancia,
          }
        })
          .then(() =>  {
            this.saving = false;
            this.close();
            this.initialize();
          })
          .catch(error => {
            this.saving = false;
            if (error.response?.status == 409) {
              const msg = error.response?.data.msg.split(':')[1]
              // this.alerta = true;
              if (msg.includes('error')){
                if(this.esAlgunaCategoriaEspecifica){
                  this.erroresItem.errornombre = "Ya existe";
                  this.errores.push(`Existe una unidad activa con el mismo Número Económico`);
                }
                else {
                  this.erroresItem.errornombre = "Ya existe";
                  this.errores.push("Existe una Máquina/Herramienta activa con el mismo Nombre/Código");
                }
              }
              else
                this.errores.push(msg);
            }
          });
      },
      cargaMasivaPost(){
        if (this.ficheroCarga == null) return;
        this.loadingCargaMasiva = true;
				let formData = new FormData();
				formData.append("formfile", this.ficheroCarga);
				axios({
          url: this.esIndasa
            ? "/MaquinaInstancias/CargaMasivaUnidadesIndasa"
            : "/MaquinaInstancias/CargaMasivaMaquinasInstancia",
          method: 'POST',
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          }
        })
					.then((response) => {
            this.erroresCarga = response.data
						this.cargaCargaCompleta = true;
						this.loadingCargaMasiva = false;
						this.initialize();
					})
					.catch((error) => {
						console.log(error);
						this.errorCargaMasiva = true;
						this.loadingCargaMasiva = false;
					});
    },
    descargarFormato(){
      var datetime = moment().format('YYYYMMDDHHmmss');
      let url = '/MaquinaInstancias/PlantillaCargaMasivaMaquinasInstancia';
      let fileName = 'CargaMasiva_Maquinas';
      if(this.esIndasa){
        url = '/MaquinaInstancias/PlantillaCargaMasivaUnidadesIndasa';
        fileName = 'CargaMasiva_Unidades';
      }
      this.$utils.axios.downloadFile(url+'?access_token='+this.token,'GET',fileName+'_'+datetime+'.csv','text/csv');
    },
    // Recibe un entero (0–100) y regresa tres arreglos:
    // { mas: > valor, igual: === valor, menos: < valor }
    // Supone que existe un array this.maquinas con { nombre, importancia }.
    clasificarPorImportancia(valor) {
      const v = Math.max(0, Math.min(100, Number.parseInt(valor, 10) || 0));

      const mas   = this.maquinas
        .filter(m => m.importancia > v)
        .sort((a, b) => b.importancia - a.importancia);

      const igual = this.maquinas
        .filter(m => m.importancia === v);

      const menos = this.maquinas
        .filter(m => m.importancia < v)
        .sort((a, b) => a.importancia - b.importancia);

      return { mas, igual, menos };
    }

    },
  }
</script>

<style scoped>
.machine-config-card {
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 18px;
  border-radius: 22px;
  padding: 24px;
  background:
    radial-gradient(circle at top right, rgba(25, 118, 210, 0.14), transparent 28%),
    linear-gradient(135deg, #ffffff 0%, #f7fafc 100%);
  border: 1px solid rgba(25, 118, 210, 0.1);
}

.machine-config-card__glow {
  position: absolute;
  inset: auto -60px -80px auto;
  width: 220px;
  height: 220px;
  background: radial-gradient(circle, rgba(25, 118, 210, 0.12), transparent 68%);
  pointer-events: none;
}

.machine-config-card__header {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  margin-bottom: 18px;
  grid-column: 1 / -1;
}

.machine-config-card > .col-6 {
  max-width: none;
  padding: 0;
}

.machine-config-card > div:last-of-type {
  grid-column: 1 / -1;
}

.machine-config-card__eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 12px;
  font-weight: 700;
  color: #1976d2;
  margin-bottom: 6px;
}

.machine-config-card__title {
  margin: 0;
  font-size: 30px;
  line-height: 1.05;
  color: #102a43;
}

.machine-config-card__subtitle {
  margin: 8px 0 0;
  color: #5c6b7a;
  max-width: 720px;
}

.machine-config-card__toolbar {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.machine-config-card__toolbar--table {
  padding: 8px 0 14px;
}

.machine-config-card__search {
  max-width: 420px;
}

.machine-config-card__cta {
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(25, 118, 210, 0.22);
}

.machine-config-table {
  background: transparent;
}

.machine-name-cell {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 0;
}

.machine-name-cell__icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(25, 118, 210, 0.1);
}

.machine-name-cell__title {
  font-weight: 700;
  color: #102a43;
}

.machine-name-cell__caption {
  font-size: 12px;
  color: #7b8794;
}

.machine-type-chip {
  font-weight: 600;
}

.machine-empty-state {
  padding: 30px 16px;
  text-align: center;
}

.machine-empty-state__title {
  margin-top: 10px;
  font-weight: 700;
  color: #334e68;
}

.machine-empty-state__subtitle {
  margin-top: 4px;
  color: #7b8794;
}

.machine-setup-dialog {
  overflow: hidden;
  border-radius: 28px !important;
  background:
    radial-gradient(circle at top left, rgba(59, 130, 246, 0.16), transparent 24%),
    linear-gradient(145deg, #f8fbff 0%, #eef6ff 44%, #f8fffd 100%);
}

.machine-setup-dialog__hero {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(280px, .7fr);
  gap: 24px;
  align-items: center;
  padding: 28px 30px 18px;
  color: #fff;
  background:
    radial-gradient(circle at 15% 20%, rgba(255,255,255,0.16), transparent 26%),
    linear-gradient(135deg, #0f172a 0%, #0f4c81 42%, #0f766e 100%);
}

.machine-setup-dialog__eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .16em;
  text-transform: uppercase;
  opacity: .76;
  margin-bottom: 8px;
}

.machine-setup-dialog__title {
  margin: 0;
  font-size: clamp(2rem, 3vw, 2.8rem);
  line-height: .96;
  font-weight: 900;
  letter-spacing: -.04em;
}

.machine-setup-dialog__subtitle {
  margin: 12px 0 0;
  max-width: 620px;
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255,255,255,.82);
}

.machine-setup-dialog__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

.machine-setup-visual {
  position: relative;
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.machine-setup-visual__orbit {
  position: absolute;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,.2);
}

.machine-setup-visual__orbit--outer {
  width: 230px;
  height: 230px;
  animation: machineOrbitSpin 18s linear infinite;
}

.machine-setup-visual__orbit--inner {
  width: 170px;
  height: 170px;
  border-style: dashed;
  animation: machineOrbitSpinReverse 11s linear infinite;
}

.machine-setup-visual__core {
  position: relative;
  width: 126px;
  height: 126px;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at 30% 30%, rgba(255,255,255,.28), transparent 24%),
    linear-gradient(145deg, rgba(255,255,255,.18) 0%, rgba(255,255,255,.06) 100%);
  border: 1px solid rgba(255,255,255,.22);
  box-shadow: 0 18px 40px rgba(15, 23, 42, .28);
  animation: machineCoreFloat 3.6s ease-in-out infinite;
}

.machine-setup-visual__icon {
  font-size: 52px !important;
}

.machine-setup-visual__gear {
  position: absolute;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,.16);
  box-shadow: 0 8px 20px rgba(15, 23, 42, .18);
}

.machine-setup-visual__gear--left {
  left: -8px;
  bottom: 18px;
  animation: machineGearSpin 4s linear infinite;
}

.machine-setup-visual__gear--right {
  top: 10px;
  right: -10px;
  animation: machineGearSpinReverse 3s linear infinite;
}

.machine-setup-visual__chip {
  position: absolute;
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .12em;
  color: #fff;
  background: rgba(255,255,255,.14);
  border: 1px solid rgba(255,255,255,.22);
  backdrop-filter: blur(8px);
}

.machine-setup-visual__chip--token {
  top: 22px;
  right: 42px;
  animation: machineChipPulse 2.8s ease-in-out infinite;
}

.machine-setup-visual__chip--variable {
  bottom: 30px;
  left: 28px;
  animation: machineChipPulse 2.8s ease-in-out infinite .8s;
}

.machine-setup-visual__chip--ranges {
  right: 18px;
  bottom: 72px;
  background: rgba(251, 146, 60, .24);
  animation: machineChipPulse 2.8s ease-in-out infinite 1.2s;
}

.machine-setup-dialog__body {
  padding: 24px 24px 18px !important;
}

.machine-setup-tokens-panel {
  order: 1;
}
.machine-setup-variables-panel {
  order: 2;
}
.machine-setup-ranges-panel {
  order: 3;
}

.machine-setup-panel {
  border-radius: 22px !important;
  border-color: rgba(148, 163, 184, 0.22) !important;
  background: linear-gradient(180deg, rgba(255,255,255,.92) 0%, #ffffff 100%) !important;
  box-shadow: 0 14px 30px rgba(15, 23, 42, .06);
}

.machine-setup-panel__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #102a43;
}

.machine-setup-panel__eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .14em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 4px;
}

.machine-setup-table {
  background: transparent;
}

.token-setup {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.token-step__head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.token-step__head--between {
  justify-content: space-between;
}
.token-step__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #1976d2;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}
.token-step__title {
  font-weight: 700;
  color: #102a43;
}
.token-active-card {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 18px;
  border: 1px solid #d7e3f0;
  border-left: 4px solid #22c55e;
  border-radius: 12px;
  padding: 14px 18px;
  background: #f8fbff;
}
.token-active-card__main {
  display: flex;
  align-items: center;
  min-width: 220px;
}
.token-active-card__name {
  font-weight: 700;
  color: #102a43;
}
.token-active-card__desc {
  font-size: 12px;
  color: #7b8794;
}
.token-active-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 22px;
  flex: 1;
}
.token-meta {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}
.token-meta__label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #94a3b8;
}
.token-history__desc {
  font-size: 12px;
  color: #7b8794;
}

.vc-bloqueo-title {
  word-break: normal;
  line-height: 1.3;
  align-items: flex-start;
}
.vc-cell__title {
  font-weight: 600;
  color: #102a43;
}
.vc-cell__chip {
  margin-top: 2px;
}
.vc-rangos {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
}
.vc-rangos__count {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
}
.vc-rangos__link {
  font-size: 12px;
  color: #1976d2;
  cursor: pointer;
}
.vc-rangos__link:hover {
  text-decoration: underline;
}
.vc-rangos__empty {
  font-size: 12px;
  color: #94a3b8;
}
.vc-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
}
.estado-switch {
  display: inline-flex;
  margin-top: 0;
  padding-top: 0;
}

.machine-setup-dialog__footer {
  padding: 0 24px 20px !important;
}

.machine-setup-dialog__footer-note {
  color: #64748b;
  font-size: 13px;
}

.clickable-text {
  color: #1976d2;
  cursor: pointer;
  margin-top: 8px;
  display: inline-block;
  text-decoration: underline;
}

@media (max-width: 960px) {
  .machine-config-card {
    padding: 18px;
    grid-template-columns: minmax(0, 1fr);
  }

  .machine-config-card__header,
  .machine-config-card__toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .machine-config-card__search {
    max-width: none;
  }

  .machine-config-card > div:last-of-type {
    grid-column: auto;
  }

  .machine-setup-dialog__hero {
    grid-template-columns: minmax(0, 1fr);
    text-align: center;
  }

  .machine-setup-dialog__meta {
    justify-content: center;
  }

  .machine-setup-dialog__body,
  .machine-setup-dialog__footer {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}

@keyframes machineOrbitSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes machineOrbitSpinReverse {
  from { transform: rotate(360deg); }
  to { transform: rotate(0deg); }
}

@keyframes machineGearSpin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes machineGearSpinReverse {
  from { transform: rotate(360deg); }
  to { transform: rotate(0deg); }
}

@keyframes machineCoreFloat {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
}

@keyframes machineChipPulse {
  0%, 100% { transform: scale(1); opacity: .9; }
  50% { transform: scale(1.08); opacity: 1; }
}

/* ============================================================
   PANEL TITLE icons (Paso 1, 2 y 3)
   ============================================================ */
.machine-setup-panel__title--with-icon {
  display: flex !important;
  align-items: flex-start !important;
  gap: 14px;
}

.machine-setup-panel__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 12px -4px rgba(15, 39, 78, 0.18);
}

.machine-setup-panel__icon--blue {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}
.machine-setup-panel__icon--teal {
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
}
.machine-setup-panel__icon--orange {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
}

.machine-setup-panel__icon >>> .v-icon {
  color: #ffffff !important;
  font-size: 22px !important;
}

/* ============================================================
   RANGO — Paso 3 redesigned
   ============================================================ */
.rango-panel__subtitle {
  font-size: 12.5px;
  font-weight: 500;
  color: #64748b;
  margin-top: 4px;
  max-width: 720px;
}

/* Variable seleccionada */
.rango-selected {
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 1px 2px rgba(15, 39, 78, 0.04);
}

.rango-selected__cell-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #1976d2;
  margin-bottom: 8px;
}

.rango-selected__cell-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.rango-selected__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(25, 118, 210, 0.10);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.rango-selected__icon >>> .v-icon {
  color: #1976d2 !important;
  font-size: 22px !important;
}

.rango-selected__title {
  font-size: 13.5px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.005em;
}

.rango-selected__sub {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.rango-selected__unidad {
  font-size: 12px;
  color: #475569;
  margin-top: 4px;
}

/* Mini-steps banner */
.rango-mini-steps {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 10px 14px;
  background: #f1f5fb;
  border-radius: 10px;
  align-items: center;
}

.rango-mini-step {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
  color: #334155;
  font-weight: 600;
}

.rango-mini-step--info {
  color: #64748b;
  font-weight: 500;
  font-size: 12px;
}

.rango-mini-step__num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 11px;
  font-weight: 800;
  flex-shrink: 0;
}

.rango-mini-step__num--green { background: #16a34a; }
.rango-mini-step__num--amber { background: #f59e0b; }

.rango-mini-step__label {
  line-height: 1.2;
}

/* 2 cards: NORMAL + ADVERTENCIA */
.rango-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.rango-card {
  position: relative;
  padding: 16px 18px;
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(15, 39, 78, 0.04);
}

.rango-card__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.rango-card__step {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
  font-weight: 800;
  flex-shrink: 0;
}

.rango-card--normal .rango-card__step { background: #16a34a; }
.rango-card--warn .rango-card__step { background: #f59e0b; }

.rango-card__title {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  line-height: 1;
}

.rango-card--normal .rango-card__title { color: #16a34a; }
.rango-card--warn .rango-card__title { color: #b45309; }

.rango-card__optional {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  padding: 2px 8px;
  margin-left: auto;
}

.rango-card__hint {
  font-size: 12px;
  color: #64748b;
  margin: 0 0 12px;
}

.rango-card__fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.rango-card__note {
  display: flex;
  gap: 6px;
  align-items: flex-start;
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 11.5px;
  line-height: 1.4;
}

.rango-card__note--ok {
  background: rgba(22, 163, 74, 0.08);
  color: #15803d;
  border: 1px solid rgba(22, 163, 74, 0.18);
}
.rango-card__note--ok >>> .v-icon { color: #16a34a !important; }

.rango-card__note--warn {
  background: rgba(245, 158, 11, 0.08);
  color: #b45309;
  border: 1px solid rgba(245, 158, 11, 0.22);
}
.rango-card__note--warn >>> .v-icon { color: #f59e0b !important; }

/* Vista previa */
.rango-preview {
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 14px;
  padding: 16px 18px 18px;
  box-shadow: 0 1px 2px rgba(15, 39, 78, 0.04);
}

.rango-preview__head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #1976d2;
  margin-bottom: 14px;
}

.rango-preview__head >>> .v-icon { color: #1976d2 !important; }

.rango-bar-legend {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.rango-bar-legend__item {
  flex: 1;
  min-width: 110px;
  text-align: center;
}

.rango-bar-legend__title {
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.rango-bar-legend__range {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
}

.rango-bar-legend__item--alarma .rango-bar-legend__title { color: #dc2626; }
.rango-bar-legend__item--adv .rango-bar-legend__title { color: #f59e0b; }
.rango-bar-legend__item--normal .rango-bar-legend__title { color: #16a34a; }

.rango-bar {
  display: flex;
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
  margin: 4px 0 6px;
}

.rango-bar__seg--alarma { background: #dc2626; }
.rango-bar__seg--adv { background: #f59e0b; }
.rango-bar__seg--normal { background: #16a34a; }

.rango-bar-axis {
  position: relative;
  height: 22px;
}

.rango-bar-axis__tick {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  font-size: 11px;
  color: #475569;
  font-weight: 600;
}

.rango-bar-axis__tick::before {
  content: "";
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 6px;
  background: #cbd5e1;
}

/* Resumen */
.rango-summary {
  background: #fafbfc;
  border: 1px solid #e6ebf2;
  border-radius: 14px;
  padding: 14px 16px 16px;
}

.rango-summary__head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #475569;
  margin-bottom: 12px;
}
.rango-summary__head >>> .v-icon { color: #475569 !important; }

.rango-summary__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px;
}

.rango-summary__cell {
  background: #ffffff;
  border-radius: 10px;
  padding: 12px 10px;
  text-align: center;
  border: 1px solid #e6ebf2;
}

.rango-summary__label {
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.rango-summary__cell--alarma { border-color: rgba(220, 38, 38, 0.25); }
.rango-summary__cell--alarma .rango-summary__label { color: #dc2626; }
.rango-summary__cell--adv { border-color: rgba(245, 158, 11, 0.28); }
.rango-summary__cell--adv .rango-summary__label { color: #b45309; }
.rango-summary__cell--normal { border-color: rgba(22, 163, 74, 0.25); }
.rango-summary__cell--normal .rango-summary__label { color: #16a34a; }

.rango-summary__sub {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 2px;
}

.rango-summary__value {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
}

/* Saved banner (cuando la variable ya tiene rango guardado) */
.rango-saved-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: linear-gradient(135deg, rgba(22, 163, 74, 0.06) 0%, rgba(22, 163, 74, 0.02) 100%);
  border: 1px solid rgba(22, 163, 74, 0.28);
  border-radius: 12px;
}

.rango-saved-banner >>> .v-icon { font-size: 28px !important; flex-shrink: 0; }

.rango-saved-banner__text { flex: 1; min-width: 0; }

.rango-saved-banner__title {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #15803d;
  margin-bottom: 2px;
}

.rango-saved-banner__sub {
  font-size: 12px;
  color: #475569;
}

.rango-saved-banner__actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.rango-saved-list {
  border: 1px solid #e6ebf2;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.rango-saved-list__toggle {
  width: 100%;
  justify-content: flex-start !important;
  min-height: 46px;
  border-radius: 0 !important;
  font-weight: 700;
}

.rango-saved-list__table {
  border-top: 1px solid #eef1f6;
  padding: 8px 10px 10px;
  background: #fafbfc;
}

.rango-status-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.rango-status-dialog__title {
  align-items: center;
  color: #0f172a;
  font-size: 18px !important;
  font-weight: 800;
  padding: 18px 20px 10px !important;
}

.rango-status-dialog__copy {
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  margin-bottom: 14px;
}

.rango-status-dialog__variable {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff8eb;
  border: 1px solid #fde6bd;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}

.rango-status-dialog__variable-icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef6ff;
  border: 1px solid #dbeafe;
  flex-shrink: 0;
}

.rango-status-dialog__variable-label {
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
}

.rango-status-dialog__variable-value {
  color: #1e293b;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  word-break: break-word;
}

.rango-status-dialog__alert {
  margin-bottom: 0 !important;
  border-radius: 8px !important;
}

.rango-status-dialog__actions {
  gap: 12px;
  padding: 0 20px 20px !important;
}

/* Footer actions del paso 3 */
.rango-footer-actions {
  display: flex !important;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #eef1f6;
  padding-top: 16px !important;
  margin-top: 6px;
}

@media (max-width: 600px) {
  .rango-saved-banner { flex-direction: column; align-items: stretch; }
  .rango-saved-banner__actions { justify-content: stretch; }
  .rango-saved-banner__actions > * { flex: 1; }
  .rango-footer-actions { flex-direction: column; align-items: stretch; }
}

@media (max-width: 960px) {
  .rango-cards { grid-template-columns: 1fr; }
  .rango-card__fields { grid-template-columns: 1fr; }
  .rango-bar-legend { gap: 6px; }
  .rango-bar-legend__item { min-width: 80px; }
}
</style>
